import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import NumberFormat from "react-number-format";
import ReactTooltip from "react-tooltip";
import Tooltip from "rc-tooltip";
import { Dropdown } from "react-bootstrap";
import "rc-tooltip/assets/bootstrap_white.css";
import Portal from "../../../common/components/Portal";
import { addToBreadCrumpData, popBreadCrumpData, findPrevPathFromBreadCrumpData, checkPermission } from "../../../../config/utils";
import ConfirmationModal from "../../../common/components/ConfirmationModal";
import EditHistory from "../../../region/components/EditHistory";
import history from "../../../../config/history";
import ShowHelperModal from "../../../helper/components/ShowHelperModal";
import moment from "moment";
import RecommendationNoteView from "../../../common/components/RecommendationNoteView";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import Editor from "ckeditor5-custom-build/build/ckeditor";
import { Band, DynamicField } from "./Band";
import { energy_fields } from "../Bands/EnergyBand";
import { water_fields } from "../Bands/WaterBand";
import { connect } from "react-redux";
import { ImageBand } from "../../../common/components/ImageComponents/ImageBand";
import OnePagerExportModal from "../OnePagerExportModal";
import { DYNAMIC_FIELD_TYPES, RECOMMENDATION_SOURCE_TYPES, RECOMMENDATION_TYPES } from "../../../common/constants";
import qs from "query-string";
import { SiteBuildingInfoModal } from "../SiteBuildingInfoModal";
import { recommendationSurveyOrder, recommendationSurveyStatus } from "../../../assetSurveyProject/constants";
import SurveyEditHistory from "../../../assetSurveyProject/components/EditHistory";
import MobileRecommendationDetail from "../../../mobileRecommendation/components/MobileRecommendationDetail";
import { FilterSearch } from "../../../mobileRecommendation/components/FilterModal/FilterSearch";
import SelectBox from "../../../images/components/SelectBox";
import { EllipsisTooltipText } from "../../../common/components/EllipsisTextWithTooltip";
import { sanitizeHtml } from "../../../common/components/SafeHtml";
import {
    formatCapitalRequestSourceValue,
    getCapitalRequestLabel,
    getCapitalRequestNarrativeLabel,
    getCapitalRequestStatusLabel,
    getCapitalRequestStatusNotesLabel
} from "../../../../utils/capitalRequestLabel";
import syncIcon from "../../../../assets/img/sync.svg";
import { CAPITAL_REQUEST_STATUS } from "../../constants";
import { getStaticRecommendationBandKeySet } from "../../../../utils/recommendationBandUtils";
import actions from "../../actions";
import "../../../../assets/css/qaband.css";
import {
    REVIEW_GATE_STATUS,
    buildCriteriaChecklistHtml,
    canMoveToQaPassed,
    getQaPassedDisabledReason,
    getReadyForQaCriteria,
    getReviewGateApiPayload,
    getReviewGateConfirmCopy,
    getReviewGateStatus,
    QA_PASSED_REQUIRES_READY_TIP
} from "../../utils/qaGateValidation";

const REVIEW_GATE_CRITERIA_TIP_ID = "main-details-review-gate-criteria";

const editorConfiguration = {
    toolbar: [],
    removePlugins: ["Title", ""],
    alignment: {
        options: ["left", "right", "center", "justify"]
    },
    highlight: {
        options: [
            { model: "yellowMarker", class: "marker-yellow", title: "Yellow marker", color: "var(--ck-highlight-marker-yellow)", type: "marker" },
            { model: "greenMarker", class: "marker-green", title: "Green marker", color: "#32CD32", type: "marker" },
            { model: "pinkMarker", class: "marker-pink", title: "Pink marker", color: "#FF00FF", type: "marker" },
            { model: "blueMarker", class: "marker-blue", title: "Blue marker", color: "#0000FF", type: "marker" }
        ]
    },
    placeholder: "Type Here..."
};

class BasicDetails extends Component {
    constructor(props) {
        super(props);
        this.templateRef = React.createRef();
        this.toggleRowRef = React.createRef();
        this.toggleWidths = {};
        this.state = {
            infoType: null,
            infoDetails: null,
            showSiteBuildingInfo: false,
            showImageModal: false,
            isHistoryView: false,
            showConfirmModalLog: false,
            selectedLog: "",
            logChanges: {},
            associated_changes: [],
            showHelperModal: false,
            selectedHelperItem: {},
            showConfirmModal: false,
            selectedBudgetPriorityData: false,
            selectedFMP: false,
            showFMPConfirmModal: false,
            showIrConfirmModal: false,
            selectedIr: false,
            exportLoader: false,
            showRLConfirmModal: false,
            selectedRL: false,
            showContinuousFCAConfirmModal: false,
            selectedContinuousFCA: false,
            pendingReviewGateStatus: null,
            visibleToggleCount: null,
            showImageEditModal: false,
            showNoteModal: false,
            editorHeight: this.props.basicDetails?.recommendation_type === RECOMMENDATION_TYPES.ASSET ? "253" : "188",
            showBand: false,
            showOnePagerExortModal: false,
            currentRecomData: null,
            showFields: [],
            showType: null
        };
    }

    openImageModal = () => {
        this.setState({
            showImageModal: true
        });
    };

    getVisibleStaticBandFields = staticBandName => {
        const { recommendation_custom_fields = {} } = this.props.recommendationsReducer?.dynamicFields || {};
        const { basicDetails = {}, staticLinking } = this.props;
        const isCR = basicDetails?.infrastructure_request === "yes";
        const fields = Object.entries(recommendation_custom_fields).flatMap(([bandName, fields]) =>
            (fields || []).map(field => ({ ...field, group_field: field?.group_field || bandName }))
        );

        return fields.filter(field => {
            if (field?.is_static_band !== true || field?.group_field !== staticBandName) return false;
            const rules = field?.rules || {};
            const visibleType = rules.visible_type ?? "both";
            const visible = visibleType === "both" || (isCR ? visibleType === "cr_only" : visibleType === "recommendation_only");
            if (!visible) return false;
            if (field?.link_static_entity === "energy" && !staticLinking?.energy) return false;
            if (field?.link_static_entity === "water" && !staticLinking?.water) return false;
            return true;
        });
    };

    renderGeoHierarchyDynamicFields = () => {
        const fields = this.getVisibleStaticBandFields("Geo Hierarchy");
        const { basicDetails = {}, invalidFields } = this.props;

        return fields.map(elem => {
            const span = Math.min(Number(elem.rules?.column_span) || 1, 4);
            return (
                <div key={elem.field_name} className={`col-md-${span * 3} basic-box`}>
                    <DynamicField elem={elem} data={basicDetails.dynamic_fields} invalidFields={invalidFields ?? {}} />
                </div>
            );
        });
    };

    renderAdditionalDetailsDynamicFields = () => {
        const fields = this.getVisibleStaticBandFields("Additional Details");
        const { basicDetails = {}, invalidFields } = this.props;

        return fields.map(elem => {
            const span = Math.min(Number(elem.rules?.column_span) || 1, 4);
            return (
                <div key={elem.field_name} className={`col-md-${span * 3} basic-box`}>
                    <DynamicField elem={elem} data={basicDetails.dynamic_fields} invalidFields={invalidFields ?? {}} />
                </div>
            );
        });
    };
    onShowSiteBuildInfo = (type, details) => {
        this.setState({
            showSiteBuildingInfo: true,
            infoType: type,
            infoDetails: details
        });
    };

    openReportNote = () => {
        this.setState({
            showNoteModal: true
        });
    };

    setToolTip(basicDetails, name, showInfoIcon = false, isInvalid) {
        return basicDetails && basicDetails.length > 20 ? (
            <Tooltip
                placement="left"
                overlay={basicDetails && basicDetails.length > 20 ? basicDetails || "" : ""}
                animation="zoom"
                defaultVisible={false}
                trigger={["hover"]}
                overlayInnerStyle={{
                    backgroundColor: "#007bff",
                    color: "white",
                    padding: "11px 17px ",
                    fontSize: "13px",
                    border: "none"
                }}
            >
                <div
                    className="codeOtr"
                    data-tip={basicDetails && basicDetails.length > 20 ? basicDetails || "" : ""}
                    data-multiline={true}
                    data-place="left"
                    data-effect="solid"
                    data-background-color="#4991ff"
                >
                    <h4>
                        {name} {showInfoIcon && <i data-for="display_formats" className="fas fa-info-circle" />}{" "}
                    </h4>
                    <h3 className="notranslate">
                        {basicDetails && basicDetails.length > 20 ? basicDetails.substring(0, 20) + "..." : basicDetails || "-"}
                    </h3>
                </div>
            </Tooltip>
        ) : (
            <div
                className="codeOtr"
                data-tip={basicDetails && basicDetails.length > 20 ? basicDetails || "" : ""}
                data-multiline={true}
                data-place="left"
                data-effect="solid"
                data-background-color="#4991ff"
            >
                <h4>
                    {name} {showInfoIcon && <i data-for="display_formats" className="fas fa-info-circle" />}
                    {isInvalid && <span className="new-span-badge mr-2">New</span>}
                </h4>
                <h3 className="notranslate">
                    {basicDetails && basicDetails.length > 20 ? basicDetails.substring(0, 20) + "..." : basicDetails || "-"}
                </h3>
            </div>
        );
    }

    setToolTipData(basicDetails, name) {
        return (
            <div
                className="txt-rcm"
                data-tip={basicDetails && basicDetails.length > 20 ? basicDetails || "" : ""}
                data-multiline={true}
                data-place="left"
                data-effect="solid"
                data-background-color="#4991ff"
            >
                <div className="txt-dtl">
                    <h4>{name}</h4>
                    <h3 className="notranslate">
                        {basicDetails && basicDetails.length > 20 ? basicDetails.substring(0, 20) + "..." : basicDetails || "-"}
                    </h3>
                </div>
            </div>
        );
    }

    handleRestoreLog = async (id, choice, changes, associated_changes) => {
        await this.setState({
            showConfirmModalLog: true,
            selectedLog: id,
            logChanges: changes,
            associated_changes: associated_changes
        });
    };

    redirectToProjectCost = () => {
        const {
            match: {
                params: { id }
            },
            location: { search = "" }
        } = this.props;
        const query = qs.parse(search);
        const newPath = `/recommendations/recommendationsinfo/${id}/softCosts${search}`;
        addToBreadCrumpData({
            key: "info",
            name: "Project Costs",
            path: newPath,
            isInnerTab: query?.is_assignedRecom === "true" ? true : false
        });
        this.props.history.push(newPath);
    };

    renderConfirmationModalLog = () => {
        const { showConfirmModalLog, logChanges, associated_changes } = this.state;
        if (!showConfirmModalLog) return null;
        return (
            <Portal
                body={
                    <ConfirmationModal
                        heading={"Do you want to restore this log?"}
                        message={logChanges}
                        associatedchanges={associated_changes}
                        onNo={() => this.setState({ showConfirmModalLog: false })}
                        onYes={this.restoreLogOnConfirm}
                        isRestore={true}
                        type={"restore"}
                        isLogChange={true}
                    />
                }
                onCancel={() => this.setState({ showConfirmModalLog: false })}
            />
        );
    };

    restoreLogOnConfirm = async () => {
        this.setState({ showConfirmModalLog: false, isHistoryView: false });
        const { selectedLog } = this.state;
        await this.props.HandleRestoreSettingsLog(selectedLog);
        await this.props.refreshinfoDetails();
        // await this.getLogData(this.props.match.params.id)
        // await this.props.getMenuItems();
        this.setState({
            selectedLog: null
        });
    };

    editClick = basicDetails => {
        if (this.props?.isMobileRecommendation) {
            this.props?.showEditPage();
        } else {
            const {
                location: { search = "" }
            } = this.props;
            if (this.props.match.params.id && basicDetails.project && basicDetails.project.id) {
                const currentParams = qs.parse(search);
                const newParams = {
                    ...currentParams,
                    p_id: basicDetails?.project?.id,
                    c_id: basicDetails?.client?.id
                };
                if (basicDetails?.infrastructure_request === "yes") {
                    newParams.is_cr = true;
                }

                const newPath = `/recommendations/edit/${this.props.match.params.id}?${qs.stringify(newParams)}`;
                addToBreadCrumpData({
                    key: "edit",
                    name: `Edit ${
                        basicDetails?.infrastructure_request === "yes"
                            ? getCapitalRequestLabel(this.props.projectReducer?.getProjectByIdResponse?.miscellaneous)
                            : "Recommendation"
                    }`,
                    path: newPath
                });
                this.props.history.push(newPath);
            }
        }
    };
    editClick_one = async basicDetails => {
        await this.props.showEditPage(basicDetails.id);
        await this.props.updateSelectedRow(basicDetails.id);
    };

    componentDidMount() {
        ReactTooltip.rebuild();
        if (typeof ResizeObserver !== "undefined" && this.toggleRowRef.current) {
            this.toggleResizeObserver = new ResizeObserver(() => this.recomputeToggleOverflow());
            this.toggleResizeObserver.observe(this.toggleRowRef.current);
        }
        this.recomputeToggleOverflow();
    }

    componentWillUnmount() {
        if (this.toggleResizeObserver) {
            this.toggleResizeObserver.disconnect();
            this.toggleResizeObserver = null;
        }
    }

    getRecommendationEditorHeight = () => {
        const minHeight = this.props.basicDetails?.recommendation_type === RECOMMENDATION_TYPES.ASSET ? 253 : 188;
        const calculatedHeight = (this.templateRef?.current?.clientHeight || 0) - 340;
        return Math.max(calculatedHeight, minHeight);
    };

    componentDidUpdate(prevProps, prevState) {
        if (
            prevProps.match?.params?.id !== this.props.match?.params?.id &&
            this.props.location?.state?.fromSourceRecommendation &&
            this.state.isHistoryView
        ) {
            this.setState({ isHistoryView: false });
        }
        if (prevProps.basicDetails !== this.props.basicDetails) {
            this.toggleWidths = {};
            this.setState({ visibleToggleCount: null }, this.recomputeToggleOverflow);
        }
        if (prevProps.basicDetails !== this.props.basicDetails || prevState.showBand !== this.state.showBand) {
            ReactTooltip.rebuild();
            setTimeout(() => {
                const height = this.getRecommendationEditorHeight();
                if (this.state.editorHeight !== height) {
                    this.setState({ editorHeight: height });
                }
            }, 500);
            if (this.props?.isMob) {
                const { showType } = this.state;
                const isSystemAsset = field =>
                    this.props?.basicDetails?.recommendation_type === "asset" &&
                    field?.group_field?.toLowerCase() === "additional details" &&
                    field?.field_name === "asset_condition_id";

                if (showType === "empty") {
                    const emptyFields = Object.entries(this.props?.mobileExtraBandValues ?? {}).reduce((acc, [key, item]) => {
                        const isEmpty = ["", null, undefined].includes(item?.value);

                        if (isSystemAsset(item)) return acc;

                        if (isEmpty) acc.push(key);
                        return acc;
                    }, []);

                    this.setState({ showFields: emptyFields });
                }

                if (showType === "new") {
                    const newFields = Object.values(this.props?.MobileExtraBands ?? [])
                        ?.flat()
                        ?.filter(field => {
                            if (isSystemAsset(field)) return false;
                            return field?.invalid;
                        })
                        ?.map(field => field?.field_name);

                    this.setState({ showFields: newFields });
                }
            }
        }
    }

    showHelperModal = async (item, subItem) => {
        await this.setState({
            showHelperModal: true,
            selectedHelperItem: {
                item,
                subItem
            }
        });
    };

    renderUploadHelperModal = () => {
        const { showHelperModal, selectedHelperItem } = this.state;
        if (!showHelperModal) return null;
        return (
            <Portal
                body={<ShowHelperModal selectedHelperItem={selectedHelperItem} onCancel={() => this.setState({ showHelperModal: false })} />}
                onCancel={() => this.setState({ showHelperModal: false })}
            />
        );
    };

    renderSiteBuildingModal = () => {
        const { showSiteBuildingInfo } = this.state;
        if (!showSiteBuildingInfo) return null;
        return (
            <Portal
                body={
                    <SiteBuildingInfoModal
                        onCancel={() => this.setState({ showSiteBuildingInfo: false })}
                        basicDetails={this.state.infoDetails}
                        infoType={this.state.infoType}
                    />
                }
                onCancel={() => this.setState({ showSiteBuildingInfo: false })}
            />
        );
    };

    updateBudgetPriority = () => {
        const { selectedBudgetPriorityData } = this.state;
        this.setState({ showConfirmModal: false });
        this.props.updateBudget({ budget_priority: selectedBudgetPriorityData ? "yes" : "no" }, this.props.match.params.id);
    };

    updateFMP = () => {
        const { selectedFMP } = this.state;
        this.setState({ showFMPConfirmModal: false });
        this.props.updateFMP({ fmp: selectedFMP ? "yes" : "no" }, this.props.match.params.id);
    };
    updateIr = () => {
        const { selectedIr } = this.state;
        this.setState({ showIrConfirmModal: false });
        this.props.updateIR({ infrastructure_request: selectedIr ? "yes" : "no" }, this.props.match.params.id);
    };
    updateRL = () => {
        const { selectedRL } = this.state;
        this.setState({ showRLConfirmModal: false });
        this.props.updateRL({ red_line: selectedRL ? "yes" : "no" }, this.props.match.params.id);
    };

    updateContinuousFCA = () => {
        const { selectedContinuousFCA } = this.state;
        this.setState({ showContinuousFCAConfirmModal: false });
        this.props.updateContinuousFCA({ continuous_fca: selectedContinuousFCA ? "yes" : "no" }, this.props.match.params.id);
    };

    showConfirmation = e => {
        this.setState({ showConfirmModal: true, selectedBudgetPriorityData: e.target.checked });
    };

    showFMPConfirmation = e => {
        this.setState({ showFMPConfirmModal: true, selectedFMP: e.target.checked });
    };

    showIrConfirmation = e => {
        this.setState({ showIrConfirmModal: true, selectedIr: e.target.checked });
    };

    showRLConfirmation = e => {
        this.setState({ showRLConfirmModal: true, selectedRL: e.target.checked });
    };

    showContinuousFCAConfirmation = e => {
        this.setState({ showContinuousFCAConfirmModal: true, selectedContinuousFCA: e.target.checked });
    };

    renderConfirmationModal = () => {
        const { showConfirmModal, selectedBudgetPriorityData } = this.state;
        if (!showConfirmModal) return null;
        return (
            <Portal
                body={
                    <ConfirmationModal
                        type="cancel"
                        heading={
                            selectedBudgetPriorityData === false
                                ? "Do you want to remove from Budget Priority?"
                                : "Do you want to add to Budget Priority "
                        }
                        // message={"This action cannot be reverted, are you sure ?"}
                        onNo={() => this.setState({ showConfirmModal: false })}
                        onYes={this.updateBudgetPriority}
                    />
                }
                onCancel={() => this.setState({ showConfirmModal: false })}
            />
        );
    };
    renderFMPConfirmationModal = () => {
        const { showFMPConfirmModal, selectedFMP } = this.state;
        if (!showFMPConfirmModal) return null;
        return (
            <Portal
                body={
                    <ConfirmationModal
                        type="cancel"
                        heading={
                            selectedFMP === false
                                ? "Do you want to remove from Master Facility Plan ?"
                                : "Do you want to add to Master Facility Plan ?"
                        }
                        onNo={() => this.setState({ showFMPConfirmModal: false })}
                        onYes={this.updateFMP}
                    />
                }
                onCancel={() => this.setState({ showFMPConfirmModal: false })}
            />
        );
    };
    renderIrConfirmationModal = () => {
        const { showIrConfirmModal, selectedIr } = this.state;
        if (!showIrConfirmModal) return null;
        const crLabel = getCapitalRequestLabel(this.props.projectReducer?.getProjectByIdResponse?.miscellaneous);
        return (
            <Portal
                body={
                    <ConfirmationModal
                        type="cancel"
                        heading={
                            selectedIr === false
                                ? `Do you want to remove from ${crLabel} ?`
                                : `Do you want to add to ${crLabel} ?`
                        }
                        onNo={() => this.setState({ showIrConfirmModal: false })}
                        onYes={this.updateIr}
                    />
                }
                onCancel={() => this.setState({ showIrConfirmModal: false })}
            />
        );
    };
    renderRLConfirmationModal = () => {
        const { showRLConfirmModal, selectedRL } = this.state;
        if (!showRLConfirmModal) return null;
        return (
            <Portal
                body={
                    <ConfirmationModal
                        type="cancel"
                        heading={selectedRL === false ? "Do you want to remove from Redlining ?" : "Do you want to add to Redlining ?"}
                        onNo={() => this.setState({ showRLConfirmModal: false })}
                        onYes={this.updateRL}
                    />
                }
                onCancel={() => this.setState({ showRLConfirmModal: false })}
            />
        );
    };

    renderContinuousFCAConfirmationModal = () => {
        const { showContinuousFCAConfirmModal, selectedContinuousFCA } = this.state;
        if (!showContinuousFCAConfirmModal) return null;
        return (
            <Portal
                body={
                    <ConfirmationModal
                        type="cancel"
                        heading={
                            selectedContinuousFCA === false ? "Do you want to remove from Continuous FCA ?" : "Do you want to add to Continuous FCA ?"
                        }
                        onNo={() => this.setState({ showContinuousFCAConfirmModal: false })}
                        onYes={this.updateContinuousFCA}
                    />
                }
                onCancel={() => this.setState({ showContinuousFCAConfirmModal: false })}
            />
        );
    };

    getReviewGateState = () => {
        const { basicDetails, imageResponse } = this.props;
        const issues = this.props.recommendationsReducer?.getAllRecommendationReviewsResponse?.recommendation_reviews || [];
        const criteria = getReadyForQaCriteria({ images: imageResponse, basicDetails, issues });
        // qa_qc_status is not among the fields RecommendationsInfo copies into basicDetails,
        // so read it from the fetched record in redux — the same source the QA/QC band uses.
        const currentStatus = getReviewGateStatus(this.props.recommendationsReducer?.getRecommendationByIdResponse);
        const readyValid = criteria.every(c => c.met);
        const qaPassedDisabledReason = getQaPassedDisabledReason(issues);
        const qaPassedBlockedByStatus = !canMoveToQaPassed(currentStatus);
        return {
            currentStatus,
            criteriaHtml: buildCriteriaChecklistHtml(criteria),
            readyValid,
            qaPassedDisabled: !readyValid || !!qaPassedDisabledReason || qaPassedBlockedByStatus,
            qaPassedTip: qaPassedDisabledReason || (qaPassedBlockedByStatus ? QA_PASSED_REQUIRES_READY_TIP : null)
        };
    };

    submitReviewGateStatus = async status => {
        const payload = getReviewGateApiPayload(status);
        if (!payload) return;
        await this.props.dispatch(actions.qaQcPassedUpdate(this.props.match.params.id, payload));
        this.setState({ pendingReviewGateStatus: null });
        this.props.refreshinfoDetails && this.props.refreshinfoDetails();
    };

    renderReviewGateConfirmationModal = () => {
        const { pendingReviewGateStatus } = this.state;
        if (!pendingReviewGateStatus) return null;
        const { heading, message } = getReviewGateConfirmCopy(pendingReviewGateStatus, this.getReviewGateState().currentStatus);
        return (
            <Portal
                body={
                    <ConfirmationModal
                        type="cancel"
                        heading={heading}
                        message={message}
                        onNo={() => this.setState({ pendingReviewGateStatus: null })}
                        onYes={() => this.submitReviewGateStatus(pendingReviewGateStatus)}
                    />
                }
                onCancel={() => this.setState({ pendingReviewGateStatus: null })}
            />
        );
    };

    getHeaderToggles = () => {
        const { basicDetails, isCapitalRequest, isAssignedRecom } = this.props;
        const is_fmp_user = localStorage.getItem("fmp_user") === "yes";
        const locked = basicDetails?.locked;
        const surveyLocked = locked || basicDetails?.is_survey_lock;
        const miscellaneous = this.props.projectReducer?.getProjectByIdResponse?.miscellaneous;
        const toggles = [];

        const showGate = basicDetails?.showQaQcBand && !isCapitalRequest && isAssignedRecom !== "true";
        if (showGate) {
            const { currentStatus, criteriaHtml, readyValid, qaPassedDisabled, qaPassedTip } = this.getReviewGateState();
            const isReady = currentStatus === REVIEW_GATE_STATUS.READY_FOR_QA;
            const isPassed = currentStatus === REVIEW_GATE_STATUS.QA_PASSED;
            toggles.push({
                key: "ready_for_qa",
                label: "Ready for QA",
                checked: isReady || isPassed,
                disabled: surveyLocked || isPassed || (!isReady && !readyValid),
                tip: isPassed ? "Uncheck QA/QC Passed first." : null,
                tipHtml: isPassed ? null : criteriaHtml,
                onChange: () =>
                    isReady
                        ? this.setState({ pendingReviewGateStatus: REVIEW_GATE_STATUS.IN_PROGRESS })
                        : this.submitReviewGateStatus(REVIEW_GATE_STATUS.READY_FOR_QA)
            });
            if (basicDetails?.isQaQcReviewerUser) {
                toggles.push({
                    key: "qa_passed",
                    label: "QA/QC Passed",
                    checked: isPassed,
                    disabled: surveyLocked || (!isPassed && qaPassedDisabled),
                    tip: isPassed ? "Uncheck to send this back to Ready for QA." : qaPassedTip || "QA/QC Passed",
                    onChange: () =>
                        this.submitReviewGateStatus(isPassed ? REVIEW_GATE_STATUS.READY_FOR_QA : REVIEW_GATE_STATUS.QA_PASSED)
                });
            }
        }

        toggles.push(
            {
                key: "red_line",
                label: "Redlining",
                checked: basicDetails.red_line === "yes",
                disabled: surveyLocked,
                onChange: this.showRLConfirmation
            },
            {
                key: "continuous_fca",
                label: "Continuous FCA",
                checked: basicDetails.continuous_fca === "yes",
                disabled: locked,
                onChange: this.showContinuousFCAConfirmation
            },
            {
                key: "infrastructure_request",
                label: getCapitalRequestLabel(miscellaneous),
                checked: basicDetails.infrastructure_request === "yes",
                disabled: true,
                onChange: this.showIrConfirmation
            },
            {
                key: "budget_priority",
                label: "Budget Priority",
                checked: basicDetails.budget_priority === "yes",
                disabled: surveyLocked,
                onChange: this.showConfirmation
            },
            {
                key: "fmp",
                label: "MFP",
                tip: "Master Facility Plan",
                checked: basicDetails.fmp === "yes",
                disabled: is_fmp_user || surveyLocked,
                onChange: this.showFMPConfirmation
            }
        );

        return toggles;
    };

    renderTogglePill = (toggle, { inMenu = false } = {}) => {
        const tipAttrs = toggle.tipHtml
            ? {
                  "data-for": REVIEW_GATE_CRITERIA_TIP_ID,
                  "data-tip": "",
                  "data-class": "qa-gate-criteria-tooltip",
                  "data-place": "bottom",
                  "data-delay-show": "300"
              }
            : toggle.tip
            ? { "data-for": "recommandation_detils", "data-tip": toggle.tip, "data-delay-show": "300" }
            : {};

        return (
            <div
                key={toggle.key}
                data-toggle-key={toggle.key}
                className={inMenu ? "header-toggle-menu__item" : "budget-pr"}
                {...tipAttrs}
            >
                <label class={`container-check ${toggle.disabled ? "cursor-diabled" : ""}`}>
                    <input type="checkbox" disabled={toggle.disabled} checked={toggle.checked} onChange={toggle.onChange} />
                    <span class="checkmark"></span>
                    {toggle.label}
                </label>
            </div>
        );
    };

    measureToggleWidths = () => {
        const row = this.toggleRowRef.current;
        if (!row) return;
        const widths = {};
        row.querySelectorAll("[data-toggle-key]").forEach(el => {
            const key = el.getAttribute("data-toggle-key");
            const style = window.getComputedStyle(el);
            widths[key] = el.getBoundingClientRect().width + parseFloat(style.marginRight || 0);
        });
        if (Object.keys(widths).length) {
            this.toggleWidths = { ...this.toggleWidths, ...widths };
        }
    };

    recomputeToggleOverflow = () => {
        const row = this.toggleRowRef.current;
        if (!row) return;

        const toggles = this.getHeaderToggles();
        const measuredAll = toggles.every(t => this.toggleWidths[t.key] > 0);
        if (!measuredAll) {
            this.measureToggleWidths();
            if (!toggles.every(t => this.toggleWidths[t.key] > 0)) return;
        }

        const parent = row.parentElement;
        if (!parent) return;
        const siblingsWidth = [...parent.children]
            .filter(child => child !== row)
            .reduce((sum, child) => {
                const style = window.getComputedStyle(child);
                return sum + child.getBoundingClientRect().width + parseFloat(style.marginLeft || 0) + parseFloat(style.marginRight || 0);
            }, 0);
        const available = parent.getBoundingClientRect().width - siblingsWidth;
        if (available <= 0) return;

        // Deliberately not measured from the live button: its width shrinks as the count
        // drops, which would free space, show another pill, and oscillate on resize.
        const MENU_W = 92;
        const total = toggles.reduce((sum, t) => sum + (this.toggleWidths[t.key] || 0), 0);

        let visibleCount = toggles.length;
        if (total > available) {
            let used = 0;
            visibleCount = 0;
            for (let idx = 0; idx < toggles.length; idx++) {
                const w = this.toggleWidths[toggles[idx].key] || 0;
                if (used + w + MENU_W > available) break;
                used += w;
                visibleCount++;
            }
            visibleCount = Math.max(visibleCount, 1);
        }

        if (visibleCount !== this.state.visibleToggleCount) {
            this.setState({ visibleToggleCount: visibleCount });
        }
    };

    renderHeaderToggles = () => {
        const toggles = this.getHeaderToggles();
        if (!toggles.length) return null;

        const { visibleToggleCount } = this.state;
        const showAll = visibleToggleCount === null;
        const visible = showAll ? toggles : toggles.slice(0, visibleToggleCount);
        const overflow = showAll ? [] : toggles.slice(visibleToggleCount);
        const criteriaHtml = this.getReviewGateState().criteriaHtml;

        return (
            <div className={`header-toggle-row ${showAll ? "is-measuring" : ""}`} ref={this.toggleRowRef}>
                {visible.map(toggle => this.renderTogglePill(toggle))}
                {overflow.length > 0 && (
                    <Dropdown className="header-toggle-more" onToggle={() => ReactTooltip.hide()}>
                        <Dropdown.Toggle
                            variant="link"
                            id="header-toggle-more-toggle"
                            className="header-toggle-more__btn"
                            data-for="recommandation_detils"
                            data-tip={overflow.map(toggle => toggle.label).join(", ")}
                            data-delay-show="300"
                        >
                            {overflow.length} more
                            <i className="fas fa-chevron-down ml-1" aria-hidden="true" />
                        </Dropdown.Toggle>
                        <Dropdown.Menu align="right" className="header-toggle-menu" renderOnMount>
                            <span className="header-toggle-menu__caret" aria-hidden="true" />
                            {overflow.map(toggle => this.renderTogglePill(toggle, { inMenu: true }))}
                        </Dropdown.Menu>
                    </Dropdown>
                )}
                <ReactTooltip
                    id={REVIEW_GATE_CRITERIA_TIP_ID}
                    className="qa-gate-criteria-tooltip"
                    html={true}
                    place="bottom"
                    effect="solid"
                    getContent={() => criteriaHtml}
                />
            </div>
        );
    };

    findPriorityText = (value, options = []) => {
        let text = "-";
        let priorityObj = options.find(option => option.id === value);
        if (priorityObj) {
            text = priorityObj.name;
        } else if (value) {
            text = value;
        }
        return text;
    };

    renderPriorityElementToolTip = (name, options = [], notes, index = "", selectedId) => {
        if (!selectedId) return null;
        if (options.length) {
            const selectedOption = options.find(opt => opt.id == selectedId);
            if (selectedOption && selectedOption.description) {
                // Return only the description if it exists
                return `<div class="priority-desc-tooltip rich-text-tooltip">${selectedOption.description}</div>`;
            }
        }
        return null;
    };

    exportRecommendation = (basicDetails, exportType) => {
        this.toggleOnePagerExportModal();
        let params = {};
        params.recommendation_id = basicDetails.id;
        params.username = localStorage.getItem("user");
        params.simple_text = basicDetails?.simple_text;
        if (basicDetails.fmp === "yes") {
            params.fmp = "True";
        }
        if (basicDetails.budget_priority === "yes") {
            params.budget_priority = "True";
        }
        if (basicDetails.infrastructure_request === "yes") {
            params.ir = "True";
        }
        params.dynamic_field_check_box = basicDetails.dynamic_field_check_box;
        params.project_id = basicDetails?.project?.id;
        params.user_id = localStorage.getItem("userId") || "";
        this.props.postExport(params, exportType);
    };

    updateImage = async imageData => {
        await this.props.updateImageComment(imageData);
        if (this.props.refreshinfoDetails) {
            await this.props.refreshinfoDetails();
        }
    };

    handleEditImage = () => {
        this.setState({ showImageEditModal: true });
    };

    toggleOnePagerExportModal = data => {
        this.setState({ showOnePagerExortModal: !this.state.showOnePagerExortModal, currentRecomData: data });
    };

    renderOnePagerExportModal = () => {
        const { showOnePagerExortModal, currentRecomData } = this.state;
        if (!showOnePagerExortModal) return null;
        const isCR = this.props.basicDetails?.infrastructure_request === "yes";
        const crLabel = getCapitalRequestLabel(this.props.projectReducer?.getProjectByIdResponse?.miscellaneous);
        return (
            <Portal
                body={
                    <OnePagerExportModal
                        onCancel={() => this.toggleOnePagerExportModal()}
                        exportRecommendation={this.exportRecommendation}
                        currentRecomData={currentRecomData}
                        NarrativeText={true}
                        heading={isCR ? `${crLabel} One Pager Export` : undefined}
                    />
                }
                onCancel={() => this.toggleOnePagerExportModal()}
            />
        );
    };

    render() {
        const {
            basicDetails,
            getAllSettingsLogs,
            logData,
            handlePerPageChangeHistory,
            handlePageClickHistory,
            handleGlobalSearchHistory,
            globalSearchKeyHistory,
            handleDeleteLog,
            historyPaginationParams,
            historyParams,
            updateLogSortFilters,
            permissions,
            logPermission,
            isNarrativeRecommendation,
            closeInfoPage,
            hasDelete = true,
            hasEdit = true,
            hasLogView = true,
            hasLogDelete = true,
            hasLogRestore = true,
            hasInfoPage = true,
            imageResponse,
            deleteImage,
            hasExport,
            hasHelp = false,
            groupedStatusOptions = null,
            invalidFields = {},
            config,
            onHistoryClick,
            onHistoryClose,
            remoteId = null,
            staticLinking,
            isMob = false,
            MobileExtraBands = {},
            mobileExtraBandValues = {},
            location: { search = "" },
            hasInitialSurveyValueBtn = false,
            handleInitialSurveyValueBtn,
            fieldSearch = "",
            setFieldSearch = null,
            searchFields = []
        } = this.props;
        const { recommendation_custom_fields = {} } = this.props.recommendationsReducer?.dynamicFields || {};
        const { isHistoryView, showType, showFields } = this.state;
        const userRole = localStorage.getItem("role");
        const show_opinions_cost_diff_indicator =
            (userRole === "super_admin" || userRole === "consultancy_user") &&
            basicDetails.project?.display_unit &&
            Math.round(basicDetails.project_total) !== Math.round(basicDetails?.total_opinions_of_cost);
        const isCR = basicDetails?.infrastructure_request === "yes";
        const miscellaneous = this.props.projectReducer?.getProjectByIdResponse?.miscellaneous;
        const crLabel = getCapitalRequestLabel(miscellaneous);
        const crNarrativeLabel = getCapitalRequestNarrativeLabel(miscellaneous);
        const crStatusLabel = getCapitalRequestStatusLabel(miscellaneous);
        const crStatusNotesLabel = getCapitalRequestStatusNotesLabel(miscellaneous);
        const isMR = this.props?.isMobileRecommendation;
        const currentParams = qs.parse(search);
        const is_assigned_recom = this.props?.isAssignedRecom && currentParams?.is_mr !== "true";

        const staticBandKeySet = getStaticRecommendationBandKeySet(this.props.recommendationsReducer?.dynamicFields);
        const dynamicBands = Object.fromEntries(
            Object.entries(recommendation_custom_fields)
                .filter(([band]) => !staticBandKeySet.has(String(band)))
                .map(([band, fields]) => {
                    const filtered = fields.filter(field => {
                        const rules = field.rules || {};
                        const vt = rules.visible_type ?? "both";

                        const visible = vt === "both" || (isCR ? vt === "cr_only" : vt === "recommendation_only");
                        if (!visible) return false;

                        if (field?.link_static_entity === "energy" && !this.props?.staticLinking?.energy) {
                            return false;
                        }
                        if (field?.link_static_entity === "water" && !this.props?.staticLinking?.water) {
                            return false;
                        }
                        return true;
                    });
                    return [band, filtered];
                })
                .filter(([, fields]) => fields.length > 0)
        );
        return (
            <React.Fragment>
                <div
                    className={`tab-active location-sec recom-sec main-dtl recommendation-form add-recommendation ${
                        basicDetails?.recommendation_type === RECOMMENDATION_TYPES.ASSET ? " " : "building-type"
                    }`}
                >
                    <ReactTooltip
                        id="recommandation_detils"
                        place="bottom"
                        className="rc-tooltip-custom-class rich-text-tooltip"
                        effect="solid"
                        backgroundColor="#007bff"
                        html={true}
                        getContent={dataTip => (dataTip ? sanitizeHtml(dataTip) : "")}
                    />
                    {!(this.props?.isHistoryViewDetail && isMR) && (
                        <div className="recom-top-nav-sec">
                            <div className="check-area-top mr-3">
                                <label htmlFor="">
                                    <span className="label-txt">ID</span>
                                    <EllipsisTooltipText
                                        className="label-detl"
                                        text={basicDetails.code || "-"}
                                        tooltipId="recommandation_detils"
                                        tooltipPlace="bottom"
                                    />
                                </label>
                                <label htmlFor="">
                                    <span className="label-txt">Type</span>
                                    <span className="label-detl">
                                        {basicDetails.recommendation_type
                                            ? basicDetails.recommendation_type?.charAt(0)?.toUpperCase() + basicDetails.recommendation_type?.slice(1)
                                            : "-"}
                                    </span>
                                </label>
                            </div>
                            <div className="otr-edit-delte text-right ed-dl d-flex align-items-center view-narrative-report">
                                {is_assigned_recom ? null : !isMR ? (
                                    <>
                                        {this.renderHeaderToggles()}
                                    </>
                                ) : (
                                    <>
                                        {isMob && setFieldSearch && (
                                            <div className="search search-box-asset mr-2 not-draggable">
                                                <FilterSearch
                                                    fieldSearch={fieldSearch}
                                                    setFieldSearch={setFieldSearch}
                                                    fields={
                                                        showType
                                                            ? (searchFields ?? []).filter(field => showFields?.includes(field?.key))
                                                            : searchFields
                                                    }
                                                />
                                            </div>
                                        )}
                                        {!showType ? (
                                            <>
                                                {(showFields?.length ||
                                                    Object.values(MobileExtraBands ?? {})
                                                        .filter(([bandKey]) => {
                                                            if (
                                                                basicDetails.recommendation_type === "system" &&
                                                                bandKey?.group_field?.toLowerCase() === "asset"
                                                            )
                                                                return false;
                                                            else return true;
                                                        })
                                                        ?.some(bandFields =>
                                                            (bandFields ?? []).some(field => {
                                                                if (
                                                                    (basicDetails.recommendation_type === "asset" &&
                                                                        field?.group_field?.toLowerCase() === "additional details" &&
                                                                        field?.field_name === "asset_condition_id") ||
                                                                    field?.field_name === "mobile_recomm_notes_temp"
                                                                ) {
                                                                    return false;
                                                                }
                                                                return ["", null, undefined].includes(field?.value);
                                                            })
                                                        )) && (
                                                    <button
                                                        type="button"
                                                        className={"add-btn btn-new-noti"}
                                                        onClick={e => {
                                                            e.preventDefault();
                                                            const emptyFields = Object.entries(mobileExtraBandValues ?? {}).reduce(
                                                                (acc, [key, item]) => {
                                                                    const isEmpty = ["", null, undefined].includes(item?.value);
                                                                    if (
                                                                        (basicDetails?.recommendation_type === "asset" &&
                                                                            item?.group_field?.toLowerCase() === "additional details" &&
                                                                            key === "asset_condition_id") ||
                                                                        key === "mobile_recomm_notes_temp"
                                                                    ) {
                                                                        return acc;
                                                                    }
                                                                    if (isEmpty) acc.push(key);
                                                                    return acc;
                                                                },
                                                                []
                                                            );
                                                            this.setState({
                                                                showType: "empty",
                                                                showFields: showFields?.length ? [] : emptyFields
                                                            });
                                                        }}
                                                    >
                                                        <i className="fas fa-eye mr-1" />
                                                        Show Empty Fields
                                                    </button>
                                                )}
                                                {(showFields?.length ||
                                                    Object.values(MobileExtraBands ?? {})
                                                        ?.filter(([bandKey]) => {
                                                            if (
                                                                basicDetails.recommendation_type === "system" &&
                                                                bandKey?.group_field?.toLowerCase() === "asset"
                                                            )
                                                                return false;
                                                            else return true;
                                                        })
                                                        ?.some(bandFields =>
                                                            (bandFields ?? []).some(field => {
                                                                if (
                                                                    basicDetails.recommendation_type === "asset" &&
                                                                    field?.group_field?.toLowerCase() === "additional details" &&
                                                                    field?.field_name === "asset_condition_id"
                                                                ) {
                                                                    return false;
                                                                }
                                                                return field?.invalid;
                                                            })
                                                        )) && (
                                                    <button
                                                        className={"add-btn ml-2 btn-new-noti"}
                                                        onClick={e => {
                                                            e.preventDefault();
                                                            const newFields = Object.values(MobileExtraBands ?? [])
                                                                ?.flat()
                                                                ?.filter(field => {
                                                                    if (
                                                                        basicDetails?.recommendation_type === "asset" &&
                                                                        field?.group_field?.toLowerCase() === "additional details" &&
                                                                        field?.field_name === "asset_condition_id"
                                                                    ) {
                                                                        return false;
                                                                    }

                                                                    return field?.invalid;
                                                                })
                                                                ?.map(field => field?.field_name);

                                                            this.setState({
                                                                showType: "new",
                                                                showFields: newFields
                                                            });
                                                        }}
                                                    >
                                                        <i className="fas fa-eye mr-1" />
                                                        Show New Fields
                                                    </button>
                                                )}
                                            </>
                                        ) : (
                                            <button
                                                className={"add-btn ml-2 btn-new-noti"}
                                                onClick={e => {
                                                    this.setState({
                                                        showType: null,
                                                        showFields: []
                                                    });
                                                }}
                                            >
                                                <i className="fas fa-eye mr-1" />
                                                Show All Fields
                                            </button>
                                        )}
                                        <div className="budget-pr d-flex mobile-recom-status">
                                            <label className="container-check d-flex pl-1">Mobile Status: </label>
                                            {isMob ? (
                                                <SelectBox
                                                    optionsList={recommendationSurveyOrder?.map(id => ({
                                                        id: parseInt(id),
                                                        name: recommendationSurveyStatus?.[id].value,
                                                        class: recommendationSurveyStatus?.[id].class,
                                                        disabled: recommendationSurveyStatus?.[id]?.disabled
                                                    }))}
                                                    value={basicDetails?.status ? basicDetails?.status : ""}
                                                    isAssetSurveyProject
                                                    isClearable={false}
                                                    handleChange={value => this.props.handleSurveyRecomStatus(basicDetails?.id, value)}
                                                    isStatus
                                                    menuPortalTarget={document.body}
                                                    menuPosition="fixed"
                                                    hasEmptySelect={false}
                                                    rowId={basicDetails?.id}
                                                    disabled={basicDetails?.status === 4 || !hasEdit}
                                                />
                                            ) : (
                                                <span className={recommendationSurveyStatus?.[basicDetails?.status]?.class ?? ""}>
                                                    {basicDetails?.status ? recommendationSurveyStatus?.[basicDetails?.status]?.value : "-"}
                                                </span>
                                            )}
                                            <label class={`container-check pl-1 ml-1`}>
                                                <span onClick={this.props?.onVideoCountClick}>Videos: </span>
                                                {this.props?.videoCount}
                                            </label>
                                            <label class={`container-check pl-1 ml-1`}>
                                                <span onClick={this.props?.onVoiceCountClick}>Voice Notes: </span>
                                                {this.props?.voiceCount}
                                            </label>
                                        </div>
                                    </>
                                )}
                                {/* <div >
                               
                                   <button onClick={()=>this.props.postExport({recommendation_id:this.props.match.params.id})}>
                                    export
                                   </button>
                            </div> */}

                                <div className="reco-main-icon-link d-flex">
                                    {hasInitialSurveyValueBtn && (
                                        <>
                                            <span
                                                className={`summary-fil-icn edit-icn-bx icon-btn-sec ml-0 mr-2`}
                                                onClick={() => handleInitialSurveyValueBtn && handleInitialSurveyValueBtn()}
                                            >
                                                <img
                                                    src={syncIcon}
                                                    alt=""
                                                    data-tip={"Show Initial Synced Data"}
                                                    data-for="recommandation_detils"
                                                    className="cursor-pointer"
                                                />
                                            </span>
                                        </>
                                    )}
                                    {hasExport && (
                                        <>
                                            {this.props.exportLoader ? (
                                                <span className="edit-icn-bx icon-btn-sec">
                                                    <div className="spinner-border text-primary" role="status">
                                                        <span className="sr-only">Loading...</span>
                                                    </div>
                                                </span>
                                            ) : (
                                                <span
                                                    onClick={() => {
                                                        this.toggleOnePagerExportModal(basicDetails);
                                                    }}
                                                    className="edit-icn-bx icon-btn-sec"
                                                    data-tip="Export"
                                                    data-for="recommandation_detils"
                                                    data-place="bottom"
                                                >
                                                    <img src="/img/export-rec.svg" alt="" />
                                                </span>
                                            )}
                                        </>
                                    )}
                                    {/* <Dropdown className="print-dpr-outr">
                                    <Dropdown.Toggle
                                        id="dropdown-basic"
                                        className=""
                                        data-tip="Export Options"
                                        data-for="recommandation_detils"
                                        data-place="left"
                                    >
                                        {this.props.exportLoader ? (
                                            <span className="edit-icn-bx icon-btn-sec">
                                                <div className="spinner-border text-primary" role="status">
                                                    <span className="sr-only">Loading...</span>
                                                </div>
                                            </span>
                                        ) : (
                                            <span className="edit-icn-bx icon-btn-sec">
                                                <img src="/img/export-rec.svg" alt="" />
                                            </span>
                                        )}
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu id="dropdown-menu">
                                        <Dropdown.Item onClick={() => this.exportRecommendation(basicDetails, "word")}>Export to Word</Dropdown.Item>
                                        <Dropdown.Item onClick={() => this.exportRecommendation(basicDetails, "pdf")}>Export to PDF</Dropdown.Item>
                                    </Dropdown.Menu>
                                </Dropdown> */}

                                    {isNarrativeRecommendation ? (
                                        <>
                                            {/* <span
                                        onClick={() => {
                                            this.props.downloadPdfReport({
                                                project_id: basicDetails?.project?.id,
                                                building_id: basicDetails?.building?.id,
                                                subsystem_id: basicDetails?.sub_system?.id
                                            });
                                        }}
                                        className="edit-icn-bx icon-btn-sec"
                                        data-tip=" View Narrative Report"
                                        data-for="recommandation_detils"
                                        data-place="top"
                                    >
                                        <img src="/img/narrative-rec.svg" alt="" />
                                    </span> */}
                                            <span
                                                className="edit-icn-bx icon-btn-sec"
                                                onClick={() => this.editClick_one(basicDetails)}
                                                data-tip="Edit"
                                                data-for="recommandation_detils"
                                                data-place="bottom"
                                            >
                                                <img src="/img/edit-rec.svg" alt="" />
                                            </span>
                                            <span
                                                onClick={closeInfoPage}
                                                className="edit-icn-bx icon-btn-sec"
                                                data-tip="Close"
                                                data-for="recommandation_detils"
                                                data-place="bottom"
                                            >
                                                <img src="/img/close-rec.svg" alt="" />
                                            </span>
                                        </>
                                    ) : (
                                        <>
                                            {/* <span
                                        onClick={() => {
                                            this.props.downloadPdfReport({
                                                project_id: basicDetails?.project?.id,
                                                building_id: basicDetails?.building?.id,
                                                subsystem_id: basicDetails?.sub_system?.id
                                            });
                                        }}
                                        className="edit-icn-bx icon-btn-sec"
                                        data-tip=" View Narrative Report"
                                        data-for="recommandation_detils"
                                        data-place="top"
                                    >
                                        <img src="/img/narrative-rec.svg" alt="" />
                                    </span> */}
                                            {hasLogView && (
                                                <span
                                                    onClick={() => {
                                                        if (isMR) {
                                                            onHistoryClick && onHistoryClick();
                                                        } else {
                                                            this.setState({ isHistoryView: !this.state.isHistoryView });
                                                        }
                                                    }}
                                                    className={`edit-icn-bx icon-btn-sec ${isMR ? "mr-2" : ""}`}
                                                    data-tip={isMR ? "" : isHistoryView ? "View Details" : "View History"}
                                                    data-for="recommandation_detils"
                                                    data-place="bottom"
                                                >
                                                    <img src="/img/history-rec.svg" alt="" />
                                                </span>
                                            )}
                                            <span
                                                onClick={async () => {
                                                    await popBreadCrumpData();
                                                    await popBreadCrumpData();
                                                    await history.push(findPrevPathFromBreadCrumpData());
                                                }}
                                                className={`edit-icn-bx icon-btn-sec ${isMR ? "mr-2" : ""}`}
                                                data-tip="Close"
                                                data-for="recommandation_detils"
                                                data-place="bottom"
                                            >
                                                <img src="/img/close-rec.svg" alt="" />
                                            </span>

                                            {(basicDetails && basicDetails.locked === true) || basicDetails?.is_survey_lock === true ? (
                                                ""
                                            ) : (
                                                <>
                                                    {!basicDetails.deleted
                                                        ? hasEdit && (
                                                              <span
                                                                  className={`edit-icn-bx icon-btn-sec ${
                                                                      isMR && basicDetails?.status === 4 ? "cursor-disabled" : ""
                                                                  }`}
                                                                  onClick={() => {
                                                                      if (isMR && basicDetails?.status === 4) return;
                                                                      this.editClick(basicDetails);
                                                                  }}
                                                                  data-tip={
                                                                      isMR && basicDetails?.status === 4 ? "Can't edit a converted recommendation" : "Edit"
                                                                  }
                                                                  data-for="recommandation_detils"
                                                                  data-place="bottom"
                                                              >
                                                                  <img src="/img/edit-rec.svg" alt="" />
                                                              </span>
                                                          )
                                                        : hasEdit && (
                                                              <span
                                                                  onClick={() => this.props.restoreRecommendation()}
                                                                  className="edit-icn-bx icon-btn-sec"
                                                                  data-tip="Restore"
                                                                  data-for="recommandation_detils"
                                                                  data-place="bottom"
                                                              >
                                                                  <img src="/img/restore-reco.svg" alt="" />
                                                              </span>
                                                          )}
                                                    {hasDelete && (
                                                        <span
                                                            onClick={() => this.props.deleteRecommendation(basicDetails.deleted || false)}
                                                            className="edit-icn-bx icon-btn-sec del"
                                                            data-tip="Delete"
                                                            data-for="recommandation_detils"
                                                            data-place="bottom"
                                                        >
                                                            <img src="/img/delete-icon.svg" alt="" />
                                                        </span>
                                                    )}
                                                </>
                                            )}
                                            {hasHelp && (
                                                <span
                                                    className="view-inner help-icon"
                                                    data-tip={`Help`}
                                                    data-for="recommandation_detils"
                                                    data-effect="solid"
                                                    data-place="bottom"
                                                    data-background-color="#007bff"
                                                    onClick={() => {
                                                        this.showHelperModal("forms", "recommendations");
                                                    }}
                                                >
                                                    <img src="/img/question-mark-icon.png" alt="" className="fil-ico" />
                                                </span>
                                            )}
                                            {this.renderUploadHelperModal()}
                                        </>
                                    )}
                                </div>
                            </div>
                        </div>
                    )}
                    {isHistoryView || this.props?.isHistoryViewDetail ? (
                        isMR ? (
                            <SurveyEditHistory
                                closeHistory={() => {
                                    onHistoryClose();
                                }}
                                editSurvey={() => {
                                    this.props?.showEditPage(this.props.match.params.id);
                                }}
                                surveyProjectId={this.props.match.params.id}
                                isMobileRecommendation={true}
                                remoteId={remoteId}
                                isMobileLog={true}
                            />
                        ) : (
                            <EditHistory
                                getAllRegionLogs={getAllSettingsLogs}
                                // changeToHistory={this.changeToHistory}
                                handlePerPageChangeHistory={handlePerPageChangeHistory}
                                handlePageClickHistory={handlePageClickHistory}
                                handleGlobalSearchHistory={handleGlobalSearchHistory}
                                globalSearchKeyHistory={globalSearchKeyHistory}
                                logData={logData}
                                handleDeleteLog={handleDeleteLog}
                                historyPaginationParams={historyPaginationParams}
                                isProjectSettings={true}
                                handleRestoreLog={this.handleRestoreLog}
                                historyParams={historyParams}
                                updateLogSortFilters={updateLogSortFilters}
                                permissions={permissions}
                                logPermission={logPermission}
                                hasLogDelete={hasLogDelete}
                                hasLogRestore={hasLogRestore}
                                hasEdit={hasEdit}
                                hasDelete={hasDelete}
                                hasInfoPage={hasInfoPage}
                                columnConfig={config}
                            />
                        )
                    ) : isMob ? (
                        <MobileRecommendationDetail
                            basicDetails={basicDetails}
                            updateImage={this.updateImage}
                            isMR={isMR}
                            isCR={isCR}
                            imageResponse={imageResponse}
                            refreshImageList={this.props?.refreshImageList}
                            invalidFields={invalidFields}
                            deleteImage={deleteImage}
                            handleBandClick={() => this.setState({ showBand: !this.state.showBand })}
                            setToolTip={this.setToolTip}
                            onCancelNote={() => this.setState({ showNoteModal: false })}
                            showNoteModal={this.state?.showNoteModal}
                            openReportNote={this.openReportNote}
                            editorHeight={this.state?.editorHeight}
                            MobileExtraBands={MobileExtraBands}
                            mobileExtraBandValues={mobileExtraBandValues}
                            editorConfiguration={editorConfiguration}
                            isMob={isMob}
                            showType={showType}
                            showFields={showFields}
                            fieldSearch={fieldSearch}
                        />
                    ) : (
                        <div className="col-md-12 detail-recom scorll-flow">
                            <div class="outer-rcm recommendations">
                                <div class="cnt-sec">
                                    <div class="row">
                                        <div class="col-md-8">
                                            <div id="accordion" ref={this.templateRef}>
                                                <div class="card">
                                                    <div class="card-header" id="headingtwo">
                                                        <div className="otr-recom-div">
                                                            <button
                                                                class="btn btn-link"
                                                                data-toggle="collapse"
                                                                onClick={() => this.setState({ showBand: !this.state.showBand })}
                                                                data-target="#collapseTwo"
                                                                aria-expanded={isCR ? "false" : "true"}
                                                                aria-controls="collapseOne"
                                                            >
                                                                Geo Hierarchy
                                                            </button>

                                                            <div class="col-md-3 basic-box ">
                                                                {this.setToolTip(
                                                                    basicDetails.region && basicDetails.region.name,
                                                                    "Region",
                                                                    false,
                                                                    invalidFields?.region?.name
                                                                )}
                                                            </div>
                                                            <div
                                                                class="col-md-3 basic-box"
                                                                onClick={() => this.onShowSiteBuildInfo("site", basicDetails?.site)}
                                                            >
                                                                {this.setToolTip(
                                                                    basicDetails?.site && basicDetails?.site.name,
                                                                    "Site",
                                                                    true,
                                                                    invalidFields?.site?.name
                                                                )}
                                                            </div>
                                                            <div
                                                                className="col-md-3 basic-box"
                                                                onClick={() => this.onShowSiteBuildInfo("building", basicDetails?.building)}
                                                            >
                                                                <Tooltip
                                                                    placement="left"
                                                                    overlay={
                                                                        <span>
                                                                            {basicDetails?.building?.name || ""}
                                                                            {basicDetails?.building?.building_description
                                                                                ? ` (${basicDetails?.building?.building_description})`
                                                                                : ""}
                                                                            {basicDetails?.building?.building_type ? (
                                                                                <>
                                                                                    <br />
                                                                                    {`Building Type: ${basicDetails?.building?.building_type}`}
                                                                                </>
                                                                            ) : (
                                                                                ""
                                                                            )}
                                                                        </span>
                                                                    }
                                                                    animation="zoom"
                                                                    defaultVisible={false}
                                                                    trigger={["hover"]}
                                                                    overlayInnerStyle={{
                                                                        backgroundColor: "#007bff",
                                                                        color: "white",
                                                                        padding: "11px 17px ",
                                                                        fontSize: "13px",
                                                                        border: "none"
                                                                    }}
                                                                >
                                                                    <div className="codeOtr">
                                                                        <h4>
                                                                            Building <i data-for="display_formats" className="fas fa-info-circle" />
                                                                            {invalidFields?.building?.name && (
                                                                                <span className="new-span-badge mr-2">New</span>
                                                                            )}
                                                                        </h4>

                                                                        <h3 className="notranslate">
                                                                            {(() => {
                                                                                const name = basicDetails?.building?.name || "";
                                                                                const desc = basicDetails?.building?.building_description;
                                                                                const type = basicDetails?.building?.building_type;

                                                                                const full =
                                                                                    name + (desc ? ` (${desc})` : "") + (type ? ` (${type})` : "");

                                                                                return full.length > 20 ? full.substring(0, 20) + "..." : full || "-";
                                                                            })()}
                                                                        </h3>
                                                                    </div>
                                                                </Tooltip>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div id="collapseTwo" class={`collapse ${isCR ? "" : "show"}`} aria-labelledby="headingtwo">
                                                        <div class="card-body">
                                                            <div class="outer-rcm basic-dtl-otr p-0">
                                                                {/* <div class="col-md-3 basic-box">
                                                                    {this.setToolTip(
                                                                        basicDetails.building && basicDetails.building.building_type,
                                                                        "Building Type",
                                                                        false,
                                                                        invalidFields?.building?.building_type
                                                                    )}
                                                                </div>{" "} */}
                                                                <div class="col-md-3 basic-box">
                                                                    {this.setToolTip(
                                                                        basicDetails?.addition?.name,
                                                                        "Addition",
                                                                        false,
                                                                        invalidFields?.addition?.name
                                                                    )}
                                                                </div>
                                                                <div class="col-md-3 basic-box">
                                                                    {this.setToolTip(
                                                                        basicDetails.floor && basicDetails.floor.name && basicDetails.floor.name,
                                                                        "Floor",
                                                                        false,
                                                                        invalidFields?.floor?.name
                                                                    )}
                                                                </div>
                                                                <div class="col-md-3 basic-box">
                                                                    {this.setToolTip(
                                                                        basicDetails && basicDetails.room && basicDetails.room,
                                                                        "Room",
                                                                        false,
                                                                        invalidFields?.room
                                                                    )}
                                                                </div>
                                                                <div class="col-md-3 basic-box">
                                                                    {this.setToolTip(
                                                                        basicDetails && basicDetails.space_type && basicDetails.space_type.name,
                                                                        "Space Type",
                                                                        false,
                                                                        invalidFields?.space_type?.name
                                                                    )}
                                                                </div>
                                                                {this.renderGeoHierarchyDynamicFields()}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="card">
                                                    <div class="card-header" id="headingOne">
                                                        <div className="otr-recom-div">
                                                            <button
                                                                class="btn btn-link"
                                                                data-toggle="collapse"
                                                                onClick={() => this.setState({ showBand: !this.state.showBand })}
                                                                data-target="#collapseOne"
                                                                aria-expanded="true"
                                                                aria-controls="collapseOne"
                                                            >
                                                                {isCR ? crLabel : "Recommendation"}
                                                            </button>

                                                            <div class="col-md-3 basic-box">
                                                                {this.setToolTip(
                                                                    basicDetails && basicDetails.trade?.name && basicDetails.trade.name,
                                                                    "Trade",
                                                                    false,
                                                                    invalidFields?.trade?.name
                                                                )}{" "}
                                                            </div>
                                                            <div class="col-md-3 basic-box">
                                                                {this.setToolTip(
                                                                    basicDetails &&
                                                                        basicDetails.system &&
                                                                        basicDetails.system.name &&
                                                                        basicDetails.system.name,
                                                                    "System",
                                                                    false,
                                                                    invalidFields?.system?.name
                                                                )}
                                                            </div>
                                                            <div class="col-md-3 basic-box">
                                                                {this.setToolTip(
                                                                    basicDetails &&
                                                                        basicDetails.sub_system &&
                                                                        basicDetails.sub_system.name &&
                                                                        basicDetails.sub_system.name,
                                                                    "Sub-System",
                                                                    false,
                                                                    invalidFields?.sub_system?.name
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div id="collapseOne" class="collapse show" aria-labelledby="headingOne">
                                                        <div class="card-body">
                                                            <div class="outer-rcm mt-1 basic-dtl-otr p-0">
                                                                <div class="col-md-12 basic-box">
                                                                    <div class="codeOtr">
                                                                        <h4>{isCR ? crLabel : "Recommendation"}</h4>
                                                                        <h3 className="notranslate">
                                                                            {(basicDetails && basicDetails.description) || "-"}
                                                                        </h3>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                {isMob ? null : basicDetails.project?.display_unit ? (
                                                    <div class="card">
                                                        <div class="card-header" id="headingTre">
                                                            <div className="otr-recom-div">
                                                                <button
                                                                    class="btn btn-link"
                                                                    data-toggle="collapse"
                                                                    onClick={() => this.setState({ showBand: !this.state.showBand })}
                                                                    data-target="#collapseTre"
                                                                    aria-expanded="false"
                                                                    aria-controls="collapseOne"
                                                                >
                                                                    Capital Spending Plan
                                                                </button>
                                                                <div class="txt-rcm ">
                                                                    <div
                                                                        class={`content-inp-card blue-sec ${
                                                                            show_opinions_cost_diff_indicator ? "triangle-highlight" : ""
                                                                        }`}
                                                                        data-tip={
                                                                            show_opinions_cost_diff_indicator
                                                                                ? "The construction cost doesn't match the opinions of cost."
                                                                                : ""
                                                                        }
                                                                        data-for="recommandation_detils"
                                                                        data-place="top"
                                                                    >
                                                                        <h3 class="p-name">Construction Cost</h3>
                                                                        <h3 class="value">
                                                                            <NumberFormat
                                                                                className="color-white"
                                                                                value={parseInt(basicDetails.project_total || 0)}
                                                                                thousandSeparator={true}
                                                                                displayType={"text"}
                                                                                prefix={"$ "}
                                                                            />
                                                                        </h3>
                                                                    </div>
                                                                </div>
                                                                <div class="txt-rcm ">
                                                                    <div class={`content-inp-card blue-sec project-cost-card`}>
                                                                        {checkPermission("forms", this.props.permissions.SOFT_COSTS, "view") && (
                                                                            <span
                                                                                className="cursor-pointer project-cost-redirect"
                                                                                onClick={this.redirectToProjectCost}
                                                                                data-tip="Go to Project Cost tab"
                                                                                data-place="top"
                                                                                data-for="recommandation_detils"
                                                                            >
                                                                                <i className="fas fa-external-link-alt" />
                                                                            </span>
                                                                        )}
                                                                        <h3 class="p-name">Project Cost</h3>
                                                                        <h3 class="value">
                                                                            <NumberFormat
                                                                                className="color-white"
                                                                                value={parseInt(basicDetails.project_costs || 0)}
                                                                                thousandSeparator={true}
                                                                                displayType={"text"}
                                                                                prefix={"$ "}
                                                                            />
                                                                        </h3>
                                                                    </div>
                                                                </div>
                                                                {basicDetails.project?.display_unit && (
                                                                    <>
                                                                        <div className="txt-rcm">
                                                                            <div class="content-inp-card">
                                                                                <div class="form-group text-center">
                                                                                    <h4>Unit</h4>
                                                                                    <h3 className="notranslate">{basicDetails.unit || "-"}</h3>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </>
                                                                )}
                                                            </div>
                                                        </div>

                                                        <div id="collapseTre" class="collapse" aria-labelledby="headingTre">
                                                            <div class="card-body add-sec">
                                                                <div class="outer-rcm mt-1">
                                                                    <div class="txt-rcm">
                                                                        <div class="content-inp-card">
                                                                            <div class="form-group text-center">
                                                                                <h4>Cost per Unit</h4>
                                                                                <h3 className="notranslate">
                                                                                    <NumberFormat
                                                                                        value={parseFloat(basicDetails.cost_per_unit || 0)}
                                                                                        thousandSeparator={true}
                                                                                        displayType={"text"}
                                                                                        prefix={"$ "}
                                                                                    />
                                                                                </h3>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div class="txt-rcm">
                                                                        <div class="content-inp-card">
                                                                            <div class="form-group text-center">
                                                                                <h4>Quantity</h4>
                                                                                <h3 className="notranslate">
                                                                                    <NumberFormat
                                                                                        value={parseFloat(basicDetails.quantity || 0)}
                                                                                        thousandSeparator={true}
                                                                                        displayType={"text"}
                                                                                    />
                                                                                </h3>
                                                                            </div>
                                                                        </div>
                                                                    </div>

                                                                    <div class="txt-rcm ">
                                                                        <div class="content-inp-card">
                                                                            <div class="form-group text-center">
                                                                                <h4>Opinions of Cost </h4>
                                                                                <h3 className="notranslate">
                                                                                    <NumberFormat
                                                                                        value={parseFloat(basicDetails.options_cost || 0)}
                                                                                        thousandSeparator={true}
                                                                                        displayType={"text"}
                                                                                        prefix={"$ "}
                                                                                        decimalScale={0}
                                                                                    />
                                                                                </h3>
                                                                            </div>
                                                                        </div>
                                                                    </div>

                                                                    {/* ocuurance & total opi cost  */}
                                                                    <div class="txt-rcm ">
                                                                        <div class="content-inp-card">
                                                                            <div class="form-group text-center">
                                                                                <h4>Number of Occurrences</h4>
                                                                                <h3 className="notranslate">
                                                                                    <NumberFormat
                                                                                        value={parseFloat(basicDetails?.occurrence || 0)}
                                                                                        thousandSeparator={true}
                                                                                        displayType={"text"}
                                                                                    />
                                                                                </h3>
                                                                            </div>
                                                                        </div>
                                                                    </div>

                                                                    <div class="txt-rcm ">
                                                                        <div class="content-inp-card">
                                                                            <div class="form-group text-center">
                                                                                <h4>Total Opinions of Cost</h4>
                                                                                <h3 className="notranslate">
                                                                                    <NumberFormat
                                                                                        value={parseFloat(basicDetails?.total_opinions_of_cost || 0)}
                                                                                        thousandSeparator={true}
                                                                                        displayType={"text"}
                                                                                        prefix={"$ "}
                                                                                        decimalScale={0}
                                                                                    />
                                                                                </h3>
                                                                            </div>
                                                                        </div>
                                                                    </div>

                                                                    {basicDetails.maintenance_years.map((item, i) => (
                                                                        <div class="txt-rcm ">
                                                                            <div class="content-inp-card">
                                                                                <div class="form-group text-center">
                                                                                    <h4>{item.year}</h4>
                                                                                    <h3 className="notranslate">
                                                                                        <NumberFormat
                                                                                            value={parseInt(item.amount) ?? "-"}
                                                                                            thousandSeparator={true}
                                                                                            displayType={"text"}
                                                                                            prefix={"$ "}
                                                                                        />
                                                                                    </h3>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    ))}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                ) : (
                                                    <div class="card">
                                                        <div class="card-header" id="headingTre">
                                                            <div className="otr-recom-div">
                                                                <button
                                                                    class="btn btn-link"
                                                                    data-toggle="collapse"
                                                                    onClick={() => this.setState({ showBand: !this.state.showBand })}
                                                                    data-target="#collapseTre"
                                                                    aria-expanded="false"
                                                                    aria-controls="collapseOne"
                                                                >
                                                                    Capital Spending Plan
                                                                </button>
                                                                <div class="txt-rcm ">
                                                                    <div class={`content-inp-card blue-sec`}>
                                                                        <h3 class="p-name">Construction Cost</h3>
                                                                        <h3 class="value">
                                                                            <NumberFormat
                                                                                className="color-white"
                                                                                value={parseInt(basicDetails.project_total || 0)}
                                                                                thousandSeparator={true}
                                                                                displayType={"text"}
                                                                            />
                                                                        </h3>
                                                                    </div>
                                                                </div>
                                                                <div class="txt-rcm ">
                                                                    <div class={`content-inp-card blue-sec project-cost-card`}>
                                                                        {checkPermission("forms", this.props.permissions.SOFT_COSTS, "view") && (
                                                                            <span
                                                                                className="cursor-pointer project-cost-redirect"
                                                                                onClick={this.redirectToProjectCost}
                                                                                data-tip="Go to Project Cost tab"
                                                                                data-place="top"
                                                                                data-for="recommandation_detils"
                                                                            >
                                                                                <i className="fas fa-external-link-alt" />
                                                                            </span>
                                                                        )}
                                                                        <h3 class="p-name">Project Cost</h3>
                                                                        <h3 class="value">
                                                                            <NumberFormat
                                                                                className="color-white"
                                                                                value={parseInt(basicDetails.project_costs || 0)}
                                                                                thousandSeparator={true}
                                                                                displayType={"text"}
                                                                            />
                                                                        </h3>
                                                                    </div>
                                                                </div>

                                                                <div class="txt-rcm "></div>
                                                            </div>
                                                        </div>

                                                        <div id="collapseTre" class="collapse" aria-labelledby="headingTre">
                                                            <div class="card-body add-sec">
                                                                <div class="outer-rcm mt-1">
                                                                    {basicDetails?.maintenance_years?.map((item, i) => {
                                                                        return (
                                                                            <>
                                                                                <div class="txt-rcm ">
                                                                                    <div class="content-inp-card">
                                                                                        <div class="form-group text-center">
                                                                                            <h4>{item.year}</h4>
                                                                                            <h3 className="notranslate">
                                                                                                <NumberFormat
                                                                                                    value={parseInt(item.amount) ?? "-"}
                                                                                                    thousandSeparator={true}
                                                                                                    displayType={"text"}
                                                                                                    prefix={"$ "}
                                                                                                />
                                                                                            </h3>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </>
                                                                        );
                                                                    })}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )}
                                                <div class="card">
                                                    <div class="card-header" id="headingFour">
                                                        <div className="otr-recom-div">
                                                            <button
                                                                class="btn btn-link"
                                                                data-toggle="collapse"
                                                                onClick={() => this.setState({ showBand: !this.state.showBand })}
                                                                data-target="#collapseFour"
                                                                aria-expanded="false"
                                                                aria-controls="collapseOne"
                                                            >
                                                                Priority
                                                            </button>
                                                            {isMob ? null : (
                                                                <div class="txt-rcm ">
                                                                    <div class="content-inp-card blue-sec">
                                                                        <h3 class="p-name">Priority Total</h3>
                                                                        <h3 class="value">{(basicDetails && basicDetails.priority) || 0}</h3>
                                                                    </div>
                                                                </div>
                                                            )}

                                                            {isMob
                                                                ? null
                                                                : basicDetails.priority_elements_data?.map((item, i) => {
                                                                      return (
                                                                          <>
                                                                              {(i === 0 || i === 1) && (
                                                                                  <div key={i} className="col-md-3 basic-box">
                                                                                      {item.options?.length ? (
                                                                                          <div
                                                                                              className="codeOtr"
                                                                                              data-tip={this.renderPriorityElementToolTip(
                                                                                                  item.display_name,
                                                                                                  item.options,
                                                                                                  item.notes,
                                                                                                  i,
                                                                                                  basicDetails.priority_elements[i]?.option_id
                                                                                              )}
                                                                                              data-for="recommandation_detils"
                                                                                              data-place="right"
                                                                                              data-html={true}
                                                                                          >
                                                                                              <h4 className="fs-13">
                                                                                                  {item.display_name || `Priority Element ${i + 1}`}
                                                                                              </h4>
                                                                                              <h3 className="fs-13">
                                                                                                  {this.findPriorityText(
                                                                                                      basicDetails.priority_elements[i]?.option_id,
                                                                                                      item.options
                                                                                                  )}
                                                                                              </h3>
                                                                                          </div>
                                                                                      ) : (
                                                                                          <div className="codeOtr">
                                                                                              <h4 className="fs-13">
                                                                                                  {item.display_name || `Priority Element ${i + 1}`}
                                                                                              </h4>
                                                                                              <h3 className="fs-13">
                                                                                                  {parseInt(
                                                                                                      basicDetails.priority_elements[i]?.element
                                                                                                  ) || "-"}
                                                                                              </h3>
                                                                                          </div>
                                                                                      )}
                                                                                  </div>
                                                                              )}
                                                                          </>
                                                                      );
                                                                  })}
                                                            {!basicDetails.priority_elements_data?.length ? (
                                                                <>
                                                                    <div className="col-md-3 basic-box border-right-last">
                                                                        <div className="codeOtr" data-for="recommandation_detils" data-place="top">
                                                                            <h4 className="fs-13">
                                                                                Criticality
                                                                                {invalidFields?.criticality?.name && (
                                                                                    <span className="new-span-badge mr-2">New</span>
                                                                                )}
                                                                            </h4>
                                                                            <h3 className="fs-13">{basicDetails?.criticality?.name || "-"}</h3>
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-md-3 basic-box border-right-last">
                                                                        <div className="codeOtr" data-for="recommandation_detils" data-place="top">
                                                                            <h4 className="fs-13">
                                                                                Criticality Type
                                                                                {invalidFields?.criticality_type && (
                                                                                    <span className="new-span-badge mr-2">New</span>
                                                                                )}
                                                                            </h4>
                                                                            <h3 className="fs-13">{basicDetails?.criticality_type || "-"}</h3>
                                                                        </div>
                                                                    </div>
                                                                </>
                                                            ) : null}
                                                        </div>
                                                    </div>

                                                    <div id="collapseFour" class="collapse" aria-labelledby="headingFour">
                                                        <div class="card-body">
                                                            <div class="outer-rcm mt-1 basic-dtl-otr p-0">
                                                                {basicDetails.priority_elements_data?.map((item, i) => {
                                                                    return (
                                                                        <>
                                                                            {i !== 0 && i !== 1 && (
                                                                                <div key={i} className="col-md-3 basic-box">
                                                                                    {item.options?.length ? (
                                                                                        <div
                                                                                            className="codeOtr"
                                                                                            data-tip={this.renderPriorityElementToolTip(
                                                                                                item.display_name,
                                                                                                item.options,
                                                                                                item.notes,
                                                                                                i,
                                                                                                basicDetails.priority_elements[i]?.option_id
                                                                                            )}
                                                                                            data-for="recommandation_detils"
                                                                                            data-place="right"
                                                                                            data-html={true}
                                                                                        >
                                                                                            <h4 className="fs-13">
                                                                                                {item.display_name || `Priority Element ${i + 1}`}
                                                                                            </h4>
                                                                                            <h3 className="fs-13">
                                                                                                {this.findPriorityText(
                                                                                                    basicDetails.priority_elements[i]?.option_id,
                                                                                                    item.options
                                                                                                )}
                                                                                            </h3>
                                                                                        </div>
                                                                                    ) : (
                                                                                        <div className="codeOtr">
                                                                                            <h4 className="fs-13">
                                                                                                {item.display_name || `Priority Element ${i + 1}`}
                                                                                            </h4>
                                                                                            <h3 className="fs-13">
                                                                                                {parseInt(
                                                                                                    basicDetails.priority_elements[i]?.element
                                                                                                ) || "-"}
                                                                                            </h3>
                                                                                        </div>
                                                                                    )}
                                                                                </div>
                                                                            )}
                                                                        </>
                                                                    );
                                                                })}
                                                                {basicDetails.priority_elements_data?.length ? (
                                                                    <>
                                                                        <div className="col-md-3 basic-box">
                                                                            <div
                                                                                className="codeOtr"
                                                                                data-for="recommandation_detils"
                                                                                data-place="top"
                                                                            >
                                                                                <h4 className="fs-13">Criticality</h4>
                                                                                <h3 className="fs-13">{basicDetails?.criticality?.name || "-"}</h3>
                                                                            </div>
                                                                        </div>
                                                                        <div className="col-md-3 basic-box">
                                                                            <div
                                                                                className="codeOtr"
                                                                                data-for="recommandation_detils"
                                                                                data-place="top"
                                                                            >
                                                                                <h4 className="fs-13">Criticality Type</h4>
                                                                                <h3 className="fs-13">{basicDetails?.criticality_type || "-"}</h3>
                                                                            </div>
                                                                        </div>
                                                                    </>
                                                                ) : null}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                {basicDetails?.recommendation_type === RECOMMENDATION_TYPES.ASSET && (
                                                    <div class="card">
                                                        <div class="card-header" id="headingFive">
                                                            <div className="otr-recom-div">
                                                                <button
                                                                    class="btn btn-link"
                                                                    data-toggle="collapse"
                                                                    onClick={() => this.setState({ showBand: !this.state.showBand })}
                                                                    data-target="#collapseFive"
                                                                    aria-expanded="false"
                                                                    aria-controls="collapseOne"
                                                                >
                                                                    Asset
                                                                </button>
                                                                <div class="col-md-3 basic-box">
                                                                    {this.setToolTip(basicDetails?.asset?.asset_name, "Asset Name")}
                                                                </div>
                                                                <div class="col-md-3 basic-box">
                                                                    {this.setToolTip(
                                                                        basicDetails?.asset?.client_asset_condition?.name,
                                                                        "Asset Condition"
                                                                    )}
                                                                </div>
                                                                <div class="col-md-3 basic-box">
                                                                    {this.setToolTip(basicDetails?.asset?.asset_tag, "Asset Tag")}
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div id="collapseFive" class="collapse" aria-labelledby="headingFive">
                                                            <div class="card-body">
                                                                <div class="outer-rcm mt-1  basic-dtl-otr p-0">
                                                                    <div class="col-md-3 basic-box">
                                                                        {this.setToolTip(
                                                                            basicDetails.asset?.manufacturer?.name,
                                                                            "Manufacturer",
                                                                            false,
                                                                            invalidFields?.asset?.manufacturer?.name
                                                                        )}
                                                                    </div>
                                                                    <div class="col-md-3 basic-box">
                                                                        {this.setToolTip(basicDetails.asset?.model_number, "Model Number")}
                                                                    </div>
                                                                    <div className="col-md-3 basic-box">
                                                                        <div class="codeOtr">
                                                                            <h4>Serial Number</h4>
                                                                            {basicDetails && basicDetails.asset?.serial_number ? (
                                                                                <h3 className="notranslate">
                                                                                    {basicDetails.asset?.serial_number || "-"}
                                                                                </h3>
                                                                            ) : (
                                                                                "-"
                                                                            )}
                                                                        </div>
                                                                    </div>
                                                                    <div class="col-md-3 basic-box">
                                                                        {this.setToolTip(basicDetails.asset?.refrigerant, "Refrigerant")}
                                                                    </div>
                                                                    <div className="col-md-3 basic-box">
                                                                        <div class="codeOtr">
                                                                            <h4>Installed Year</h4>
                                                                            {basicDetails && basicDetails.asset?.installed_year ? (
                                                                                <h3 className="notranslate">
                                                                                    {basicDetails.asset?.installed_year || "-"}
                                                                                </h3>
                                                                            ) : (
                                                                                "-"
                                                                            )}
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-md-3 basic-box">
                                                                        <div class="codeOtr">
                                                                            <h4>Current Age</h4>
                                                                            {basicDetails && basicDetails.asset?.current_age ? (
                                                                                <h3 className="notranslate">
                                                                                    {basicDetails.asset?.current_age || "-"}
                                                                                </h3>
                                                                            ) : (
                                                                                "-"
                                                                            )}
                                                                        </div>
                                                                    </div>
                                                                    <div class="col-md-3 basic-box">
                                                                        {this.setToolTip(basicDetails.asset?.service_life, "Service Life")}
                                                                    </div>
                                                                    <div className="col-md-3 basic-box">
                                                                        <div class="codeOtr">
                                                                            <h4>End of Service Life</h4>
                                                                            <h3 className="notranslate">
                                                                                {basicDetails?.asset?.usefull_life_remaining ||
                                                                                basicDetails?.asset?.usefull_life_remaining === 0
                                                                                    ? `${
                                                                                          new Date().getFullYear() +
                                                                                          parseInt(basicDetails?.asset?.usefull_life_remaining)
                                                                                      }`
                                                                                    : "-"}
                                                                            </h3>
                                                                        </div>
                                                                    </div>
                                                                    <div class="col-md-3 basic-box">
                                                                        <div
                                                                            className="codeOtr"
                                                                            data-tip={
                                                                                basicDetails.asset?.usefull_life_remaining
                                                                                    ? `Year= ${
                                                                                          new Date().getFullYear() +
                                                                                          basicDetails.asset?.usefull_life_remaining
                                                                                      }`
                                                                                    : ""
                                                                            }
                                                                            data-for="recommandation_detils"
                                                                            data-place="top"
                                                                        >
                                                                            <h4>Useful Life Remaining</h4>
                                                                            <h3 className="notranslate">
                                                                                {basicDetails.asset?.usefull_life_remaining}
                                                                            </h3>
                                                                        </div>
                                                                    </div>
                                                                    <div class="col-md-3 basic-box">
                                                                        {this.setToolTip(basicDetails.asset?.capacity, "Capacity")}
                                                                    </div>
                                                                    <div class="col-md-3 basic-box">
                                                                        {this.setToolTip(basicDetails.asset?.capacity_unit, "Capacity Unit")}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )}
                                                {basicDetails?.fmp === "yes" && (
                                                    <div class="card">
                                                        <div class="card-header" id="headingSeven">
                                                            <div className="otr-recom-div">
                                                                <button
                                                                    class="btn btn-link"
                                                                    data-toggle="collapse"
                                                                    onClick={() => this.setState({ showBand: !this.state.showBand })}
                                                                    data-target="#collapseSeven"
                                                                    aria-expanded="false"
                                                                    aria-controls="collapseOne"
                                                                >
                                                                    Master Facility Plan
                                                                </button>
                                                                <div class="col-md-3 basic-box">
                                                                    {this.setToolTip(basicDetails?.fmp_id, "MFP ID")}
                                                                </div>
                                                                <div class="col-md-3 basic-box">
                                                                    {this.setToolTip(basicDetails?.fmp_project, "MFP Project")}
                                                                </div>
                                                                <div class="col-md-3 basic-box">
                                                                    {this.setToolTip(basicDetails?.fmp_track, "MFP Track")}
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div id="collapseSeven" class="collapse" aria-labelledby="headingSeven">
                                                            <div class="card-body"></div>
                                                        </div>
                                                    </div>
                                                )}
                                                <div class="card">
                                                    <div class="card-header" id="headingSix">
                                                        <div className="otr-recom-div">
                                                            <button
                                                                class="btn btn-link"
                                                                data-toggle="collapse"
                                                                onClick={() => this.setState({ showBand: !this.state.showBand })}
                                                                data-target="#collapseSix"
                                                                aria-expanded="false"
                                                                aria-controls="collapseOne"
                                                            >
                                                                Additional Details
                                                            </button>
                                                            {basicDetails?.recommendation_type === RECOMMENDATION_TYPES.SYSTEM && (
                                                                <div class="col-md-3 basic-box">
                                                                    {this.setToolTip(basicDetails && basicDetails.condition?.name, "Condition")}
                                                                </div>
                                                            )}
                                                            <div class="col-md-3 basic-box">
                                                                {this.setToolTip(
                                                                    basicDetails &&
                                                                        basicDetails.category &&
                                                                        basicDetails.category.name &&
                                                                        basicDetails.category.name,
                                                                    "Category",
                                                                    false,
                                                                    invalidFields?.category?.name
                                                                )}
                                                            </div>
                                                            {[RECOMMENDATION_TYPES.SYSTEM, RECOMMENDATION_TYPES.ASSET].includes(
                                                                basicDetails?.recommendation_type
                                                            ) && (
                                                                <div className="col-md-3 basic-box">
                                                                    <div class="codeOtr">
                                                                        <h4>
                                                                            Capital Type{" "}
                                                                            {invalidFields?.capital_type_display_name?.name && (
                                                                                <span className="new-span-badge mr-2">New</span>
                                                                            )}
                                                                        </h4>

                                                                        {basicDetails && basicDetails.capital_type_display_name ? (
                                                                            <h3 className="notranslate">{basicDetails.capital_type_display_name}</h3>
                                                                        ) : (
                                                                            "-"
                                                                        )}
                                                                    </div>
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>

                                                    <div id="collapseSix" class="collapse" aria-labelledby="headingSix">
                                                        <div class="card-body">
                                                            <div class="outer-rcm mt-1  basic-dtl-otr p-0">
                                                                {basicDetails && basicDetails.recommendation_type === RECOMMENDATION_TYPES.SYSTEM ? (
                                                                    <>
                                                                        {basicDetails?.infrastructure_request === "yes" ? (
                                                                            <>
                                                                                <div class="col-md-3 basic-box">
                                                                                    <div class="codeOtr">
                                                                                        <h4>{crStatusLabel}</h4>
                                                                                        <h3
                                                                                            className={`notranslate ${
                                                                                                CAPITAL_REQUEST_STATUS?.find(
                                                                                                    e => e.id === basicDetails?.cr_status
                                                                                                )?.class ?? ""
                                                                                            }`}
                                                                                        >
                                                                                            {CAPITAL_REQUEST_STATUS?.find(
                                                                                                e => e.id === basicDetails?.cr_status
                                                                                            )?.name ?? ""}
                                                                                        </h3>
                                                                                    </div>
                                                                                </div>
                                                                                <div class="col-md-3 basic-box">
                                                                                    <DynamicField
                                                                                        elem={{
                                                                                            label: crStatusNotesLabel,
                                                                                            field_name: "cr_status_notes",
                                                                                            rules: {},
                                                                                            field_type: DYNAMIC_FIELD_TYPES.MEMO
                                                                                        }}
                                                                                        flat_value={basicDetails?.cr_status_notes}
                                                                                        data={basicDetails}
                                                                                    />
                                                                                </div>
                                                                            </>
                                                                        ) : (
                                                                            <>
                                                                                <div class="col-md-3 basic-box">
                                                                                    <div class="codeOtr">
                                                                                        <h4
                                                                                            onClick={() =>
                                                                                                this.onShowSiteBuildInfo(
                                                                                                    "Status",
                                                                                                    groupedStatusOptions
                                                                                                )
                                                                                            }
                                                                                        >
                                                                                            Status{" "}
                                                                                            {
                                                                                                <i
                                                                                                    data-for="display_formats"
                                                                                                    className="fas fa-info-circle"
                                                                                                />
                                                                                            }{" "}
                                                                                        </h4>
                                                                                        <h3 className="notranslate">
                                                                                            {basicDetails && basicDetails.status
                                                                                                ? basicDetails.status.name
                                                                                                : "-"}
                                                                                        </h3>
                                                                                    </div>
                                                                                </div>
                                                                                <div class="col-md-3 basic-box">
                                                                                    <DynamicField
                                                                                        elem={{
                                                                                            label: "Status Notes",
                                                                                            field_name: "status_notes",
                                                                                            rules: {},
                                                                                            field_type: DYNAMIC_FIELD_TYPES.MEMO
                                                                                        }}
                                                                                        flat_value={basicDetails?.status_notes}
                                                                                        data={basicDetails}
                                                                                    />
                                                                                </div>
                                                                            </>
                                                                        )}
                                                                        <div class="col-md-3 basic-box">
                                                                            {this.setToolTip(
                                                                                basicDetails &&
                                                                                    basicDetails.funding_source &&
                                                                                    basicDetails.funding_source.name,
                                                                                "Funding",
                                                                                false,
                                                                                invalidFields?.funding_source?.name
                                                                            )}
                                                                        </div>
                                                                        <div class="col-md-3 basic-box">
                                                                            {this.setToolTip(
                                                                                basicDetails && basicDetails.responsibility?.name,
                                                                                "Responsibility",
                                                                                false,
                                                                                invalidFields?.responsibility?.name
                                                                            )}
                                                                        </div>
                                                                        <div class="col-md-3 basic-box">
                                                                            {this.setToolTip(
                                                                                basicDetails && basicDetails.installed_year,
                                                                                "Installed Year"
                                                                            )}
                                                                        </div>
                                                                        <div className="col-md-3 basic-box">
                                                                            <div class="codeOtr">
                                                                                <h4>Current Age</h4>
                                                                                <h3 className="notranslate">
                                                                                    {basicDetails?.current_age || basicDetails?.current_age === 0
                                                                                        ? basicDetails.current_age
                                                                                        : "-"}
                                                                                </h3>
                                                                            </div>
                                                                        </div>
                                                                        <div class="col-md-3 basic-box">
                                                                            {this.setToolTip(
                                                                                basicDetails && basicDetails.service_life,
                                                                                "Service Life"
                                                                            )}
                                                                        </div>
                                                                        <div className="col-md-3 basic-box">
                                                                            <div class="codeOtr">
                                                                                <h4>End of Service Life</h4>
                                                                                <h3 className="notranslate">
                                                                                    {basicDetails?.end_of_service_life ||
                                                                                    basicDetails?.end_of_service_life === 0
                                                                                        ? basicDetails.end_of_service_life
                                                                                        : "-"}
                                                                                </h3>
                                                                            </div>
                                                                        </div>
                                                                        <div class="col-md-3 basic-box">
                                                                            <div
                                                                                className="codeOtr"
                                                                                data-tip={
                                                                                    basicDetails?.end_of_service_life ||
                                                                                    basicDetails?.end_of_service_life === 0
                                                                                        ? `Year= ${basicDetails.end_of_service_life}`
                                                                                        : ""
                                                                                }
                                                                                data-for="recommandation_detils"
                                                                                data-place="top"
                                                                            >
                                                                                <h4>Useful Life Remaining</h4>
                                                                                <h3 className="notranslate">
                                                                                    {basicDetails?.usefull_life_remaining ||
                                                                                    basicDetails?.usefull_life_remaining === 0
                                                                                        ? basicDetails.usefull_life_remaining
                                                                                        : "-"}
                                                                                </h3>
                                                                            </div>
                                                                        </div>
                                                                        <div className="col-md-3 basic-box">
                                                                            <div class="codeOtr">
                                                                                <h4>CRV</h4>
                                                                                <h3 className="notranslate">
                                                                                    <NumberFormat
                                                                                        value={parseInt(basicDetails?.crv || 0)}
                                                                                        thousandSeparator={true}
                                                                                        displayType={"text"}
                                                                                        prefix={"$ "}
                                                                                    />
                                                                                </h3>
                                                                            </div>
                                                                        </div>
                                                                    </>
                                                                ) : (
                                                                    <>
                                                                        <div className="col-md-3 basic-box">
                                                                            <div class="codeOtr">
                                                                                <h4
                                                                                    onClick={() =>
                                                                                        this.onShowSiteBuildInfo("Status", groupedStatusOptions)
                                                                                    }
                                                                                >
                                                                                    Status
                                                                                    {
                                                                                        <i
                                                                                            data-for="display_formats"
                                                                                            className="fas fa-info-circle"
                                                                                        />
                                                                                    }{" "}
                                                                                </h4>
                                                                                <h3 className="notranslate">
                                                                                    {basicDetails && basicDetails.status
                                                                                        ? basicDetails.status?.name
                                                                                        : "-"}
                                                                                </h3>
                                                                            </div>
                                                                        </div>
                                                                        <div class="col-md-3 basic-box">
                                                                            <DynamicField
                                                                                elem={{
                                                                                    label: "Status Notes",
                                                                                    field_name: "status_notes",
                                                                                    rules: {},
                                                                                    field_type: DYNAMIC_FIELD_TYPES.MEMO
                                                                                }}
                                                                                flat_value={basicDetails?.status_notes}
                                                                                data={basicDetails}
                                                                            />
                                                                        </div>
                                                                        <div class="col-md-3 basic-box">
                                                                            {this.setToolTip(
                                                                                basicDetails &&
                                                                                    basicDetails.funding_source &&
                                                                                    basicDetails.funding_source.name,
                                                                                "Funding",
                                                                                false,
                                                                                invalidFields?.funding_source?.name
                                                                            )}
                                                                        </div>
                                                                        <div class="col-md-3 basic-box">
                                                                            {this.setToolTip(
                                                                                basicDetails && basicDetails.responsibility?.name,
                                                                                "Responsibility",
                                                                                false,
                                                                                invalidFields?.responsibility?.name
                                                                            )}
                                                                        </div>
                                                                    </>
                                                                )}
                                                                <div class="col-md-3 basic-box">
                                                                    {this.setToolTip(
                                                                        basicDetails &&
                                                                            basicDetails.department &&
                                                                            basicDetails.department.name &&
                                                                            basicDetails.department.name,
                                                                        "Department",
                                                                        false,
                                                                        invalidFields?.department?.name
                                                                    )}
                                                                </div>
                                                                <div class="col-md-3 basic-box">
                                                                    {this.setToolTip(
                                                                        basicDetails && basicDetails.initiative?.name,
                                                                        "Inititative Name",
                                                                        false,
                                                                        invalidFields?.initiative?.name
                                                                    )}
                                                                </div>

                                                                <div class="col-md-3 basic-box">
                                                                    {this.setToolTip(
                                                                        formatCapitalRequestSourceValue(
                                                                            basicDetails?.source,
                                                                            this.props.projectReducer?.getProjectByIdResponse?.miscellaneous
                                                                        ),
                                                                        "Origin"
                                                                    )}
                                                                </div>
                                                                <div class="col-md-3 basic-box">
                                                                    {this.setToolTip(basicDetails?.birth_year, "Birth Year")}
                                                                </div>
                                                                {this.renderAdditionalDetailsDynamicFields()}
                                                                <div class="col-md-3 basic-box">
                                                                    {this.setToolTip(
                                                                        Array.isArray(basicDetails?.years_with_value)
                                                                            ? basicDetails.years_with_value.join(", ")
                                                                            : basicDetails?.years_with_value,
                                                                        "Year(s)"
                                                                    )}
                                                                </div>
                                                                {isMR && (
                                                                    <>
                                                                        <div class="col-md-3 basic-box">
                                                                            {this.setToolTip(basicDetails?.latitude, "Latitude")}
                                                                        </div>{" "}
                                                                        <div class="col-md-3 basic-box">
                                                                            {this.setToolTip(basicDetails?.longitude, "Longitude")}
                                                                        </div>
                                                                    </>
                                                                )}
                                                            </div>

                                                            <div class="form-row m-0">
                                                                {(isCR || basicDetails?.source === RECOMMENDATION_SOURCE_TYPES.CAPITAL_REQUEST) && (
                                                                    <>
                                                                        <div class="col-md-3 p-0">
                                                                            <div class="outer-rcm">
                                                                                <div class="txt-rcm w-100">
                                                                                    <div>
                                                                                        <img src="/img/icn1.png" alt="" />
                                                                                    </div>
                                                                                    <div class="txt-secn">
                                                                                        <h4>Requester</h4>
                                                                                        <h3 className="notranslate">
                                                                                            {(basicDetails && basicDetails.requestor?.name) || "-"}
                                                                                        </h3>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        <div class="col-md-3 p-0">
                                                                            <div class="outer-rcm">
                                                                                <div class="txt-rcm w-100">
                                                                                    <div>
                                                                                        <img src="/img/icn-2.png" alt="" />
                                                                                    </div>
                                                                                    <div class="txt-secn">
                                                                                        <h4>Requested Date</h4>
                                                                                        <h3 className="notranslate">
                                                                                            {(basicDetails.requested_date &&
                                                                                                moment(basicDetails.requested_date).format(
                                                                                                    "MM-DD-YYYY"
                                                                                                )) ||
                                                                                                "-"}
                                                                                        </h3>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </>
                                                                )}
                                                                {!isCR && (
                                                                    <>
                                                                        <div class="col-md-3 p-0">
                                                                            <div class="outer-rcm">
                                                                                <div class="txt-rcm w-100">
                                                                                    <div>
                                                                                        <img src="/img/icn1.png" alt="" />
                                                                                    </div>
                                                                                    <div class="txt-secn">
                                                                                        <h4>Surveyor</h4>
                                                                                        <h3 className="notranslate">
                                                                                            {(basicDetails && basicDetails.surveyor) || "-"}
                                                                                        </h3>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        <div class="col-md-3 p-0">
                                                                            <div class="outer-rcm">
                                                                                <div class="txt-rcm w-100">
                                                                                    <div>
                                                                                        <img src="/img/icn-2.png" alt="" />
                                                                                    </div>
                                                                                    <div class="txt-secn">
                                                                                        <h4>Inspection Date</h4>
                                                                                        <h3 className="notranslate">
                                                                                            {(basicDetails.inspection_date &&
                                                                                                moment(basicDetails.inspection_date).format(
                                                                                                    "MM-DD-YYYY"
                                                                                                )) ||
                                                                                                "-"}
                                                                                        </h3>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </>
                                                                )}
                                                                <div class="col-md-3 p-0">
                                                                    <div class="outer-rcm">
                                                                        <div class="txt-rcm w-100">
                                                                            <div>
                                                                                <img src="/img/icn-3.png" alt="" />
                                                                            </div>
                                                                            <div class="txt-secn">
                                                                                <h4>Created At</h4>
                                                                                <h3 className="notranslate">
                                                                                    {moment(basicDetails.created_at).format("MM-DD-YYYY h:mm A") ||
                                                                                        "-"}
                                                                                </h3>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div class="col-md-3 p-0">
                                                                    <div class="outer-rcm">
                                                                        <div class="txt-rcm w-100">
                                                                            <div>
                                                                                <img src="/img/icn-3.png" alt="" />
                                                                            </div>
                                                                            <div class="txt-secn">
                                                                                <h4>Updated At</h4>
                                                                                <h3 className="notranslate">
                                                                                    {moment(basicDetails.updated_at).format("MM-DD-YYYY h:mm A") ||
                                                                                        "-"}
                                                                                </h3>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                {basicDetails.energy_band_show === "yes" && !staticLinking?.energy && (
                                                    <Band
                                                        bandName="Energy"
                                                        bandId="energyBand"
                                                        setToolTip={this.setToolTip}
                                                        data={basicDetails.energy_band}
                                                        fields={energy_fields}
                                                        handleBandClick={() => this.setState({ showBand: !this.state.showBand })}
                                                    />
                                                )}
                                                {basicDetails.water_band_show === "yes" && !staticLinking?.water && (
                                                    <Band
                                                        bandName="Water"
                                                        bandId="waterBand"
                                                        setToolTip={this.setToolTip}
                                                        data={basicDetails.water_band}
                                                        fields={water_fields}
                                                        handleBandClick={() => this.setState({ showBand: !this.state.showBand })}
                                                    />
                                                )}
                                                {dynamicBands &&
                                                    typeof dynamicBands === "object" &&
                                                    Object.entries(dynamicBands)?.map(([band, fields]) => (
                                                        <Band
                                                            bandName={band}
                                                            bandId={band?.split(" ")?.join("_")}
                                                            setToolTip={this.setToolTip}
                                                            data={basicDetails.dynamic_fields}
                                                            fields={fields}
                                                            handleBandClick={() => this.setState({ showBand: !this.state.showBand })}
                                                            isDynamic
                                                            invalidFields={invalidFields ?? {}}
                                                        />
                                                    ))}
                                            </div>
                                        </div>
                                        <div class="col-md-4 back-set">
                                            <div className="details-img-block details-img-new" style={{ height: "250px" }}>
                                                <ImageBand
                                                    basicDetails={basicDetails}
                                                    updateImage={this.updateImage}
                                                    deleteImage={deleteImage}
                                                    getAllImagesResponse={imageResponse}
                                                    hasEdit={!isMR}
                                                    refreshImageList={this.props.refreshImageList}
                                                    isSurveyAssetView={isMR}
                                                />
                                            </div>
                                            {this.state.showNoteModal && (
                                                <Portal
                                                    body={
                                                        <RecommendationNoteView
                                                            notes={basicDetails?.note_html || ""}
                                                            onCancel={() => this.setState({ showNoteModal: false })}
                                                            isRecommendationView={true}
                                                            isCR={isCR}
                                                        />
                                                    }
                                                    onCancel={() => this.setState({ showNoteModal: false })}
                                                />
                                            )}
                                            <div class="template">
                                                <div class="heading">
                                                    <h3>{isCR ? crNarrativeLabel : isMR ? "Mobile Rec." : "Recommendation Narrative"}</h3>
                                                    <img
                                                        data-tip={`Click to Expand ${isCR ? crLabel : "Recommendation"} Narrative`}
                                                        data-for="recommandation_detils"
                                                        data-class="rc-tooltip-custom-class"
                                                        data-place="left"
                                                        style={{ cursor: "pointer" }}
                                                        onClick={() => this.openReportNote()}
                                                        src="/img/expand1.svg"
                                                        alt=""
                                                    />
                                                </div>
                                                <div
                                                    class="cnt-temp-area notes-outer-area content-break overflow-ht-outer notranslate"
                                                    style={{ maxHeight: `${this.state.editorHeight}px` }}
                                                >
                                                    {" "}
                                                    <CKEditor
                                                        config={{ ...editorConfiguration, toolBar: [] }}
                                                        editor={Editor}
                                                        onReady={editor => {
                                                            editor?.setData(basicDetails?.note_html ? basicDetails?.note_html : "");
                                                            editor.enableReadOnlyMode("my-feature-id");
                                                        }}
                                                        data={basicDetails.note_html || ""}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                    {this.renderConfirmationModalLog()}
                    {this.renderConfirmationModal()}
                    {this.renderFMPConfirmationModal()}
                    {this.renderIrConfirmationModal()}
                    {this.renderRLConfirmationModal()}
                    {this.renderContinuousFCAConfirmationModal()}
                    {this.renderReviewGateConfirmationModal()}
                    {this.renderOnePagerExportModal()}
                    {this.renderSiteBuildingModal()}
                </div>
            </React.Fragment>
        );
    }
}

const mapStateToProps = state => {
    const { recommendationsReducer, projectReducer } = state;
    return { recommendationsReducer, projectReducer };
};

export default withRouter(connect(mapStateToProps)(BasicDetails));
